import {
    Component,
    ViewChild,
    ElementRef,
    Input,
    ViewEncapsulation,
    Output,
    EventEmitter,
    AfterViewChecked,
    OnDestroy,
    HostListener,
    ApplicationRef,
    ComponentFactoryResolver,
    Injector,
    Renderer2, OnChanges, SimpleChanges
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import 'slickgrid/lib/firebugx';
import 'slickgrid/lib/jquery-1.12.4.min';
import 'slickgrid/lib/jquery-ui.min';
import 'slickgrid/lib/jquery.event.drag-2.3.0';
import 'slickgrid/lib/jquery.event.drop-2.3.0';
import 'slickgrid/lib/jquery.mousewheel';
import 'slickgrid/slick.core';
import 'slickgrid/slick.grid';
import 'slickgrid/slick.editors';
import 'slickgrid/slick.dataview';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import 'slickgrid/plugins/slick.rowselectionmodel';
import 'slickgrid/plugins/slick.cellselectionmodel';
import 'slickgrid/plugins/slick.cellrangeselector';
import 'slickgrid/plugins/slick.cellrangedecorator';
import 'slickgrid/plugins/slick.headerbuttons';
import 'slickgrid/slick.groupitemmetadataprovider';
import 'slickgrid-column-data-autosize/dist/slick.autocolumnsize';
import 'slickgrid/plugins/slick.cellexternalcopymanager';
import * as Popper from 'popper.js/dist/umd/popper';

import {IAngularEditor} from 'app/slick-grid/interfaces/angular-editor';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {IDataSorter} from 'app/slick-grid/interfaces/data-sorter';
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column'
import {DropdownFilterType} from 'app/slick-grid/interfaces/dropdown-filter-type';
import {OnDropdownFilteredEventArgs} from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import {StocksHelper} from 'app/stocks/models/stocks-helper'
import {SlickGridFilterHelper} from 'app/slick-grid/models/slick-grid-filter-helper'
import {OnGroupingEventArgs} from "./models/on-grouping-event-args";
import {AggregationSelector, Aggregation} from "../stocks/models/aggregation-selector";
import {GetSlickGridProp} from "../shared/models/get-slick-grid-prop";
import {CommonDataService} from "../services/common-data.service";
import {SlickGridColumns} from "../shared/models/slick-grid-columns";
import {SlickFilterItem} from "./models/slick-filter-item";
import {UniversalListSettings} from "../shared/models/universal-list";
import {ColumnsGenerator} from "./models/columns-generator";
import {ColumnSettingsBase} from "./models/column-settings-base";
import {ModuleTableName} from "../shared/models/module-table-name";
import EditorLock = Slick.EditorLock;
import * as moment from 'moment';
import {Moment} from 'moment';
import {CommonService} from "../services/common.service";
import {FontSize} from "../shared/models/font-size";
import {BTControl} from "../stocks/models/b-t-control";
import {CustomFunctionReturn} from "./models/custom-function-return";
import {OrderOpened} from "../orders/models/order-opened";
import {SlickGridComponent} from "./slick-grid.component";
import {DateTimeEditorOrd} from "../shared/models/date-time-editor";
import CellCssStylesHash = Slick.CellCssStylesHash;
import {string} from "@amcharts/amcharts4/core";
import {DateTimeEditorOptions} from "../shared/models/date-time-editor-options";
import {TranslateType} from "../shared/models/translateType";
import Timer = NodeJS.Timer;
import {MainHelper} from "../shared/models/main-helper";


export class SlickGridComponentBase implements AfterViewChecked, OnDestroy, OnChanges{
    constructor(
        private readonly appRef: ApplicationRef,
        private readonly resolver: ComponentFactoryResolver,
        private readonly injector: Injector,
        public readonly renderer: Renderer2,
        public readonly translateService: TranslateService,
        private readonly elementRef: ElementRef,
        private readonly commonData: CommonDataService,
        private readonly common: CommonService
    ){
        this.onClick = new EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>();
        this.onDblClick = new EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>();
        this.onKeyDown = new EventEmitter<EventArgs<Slick.OnKeyDownEventArgs<any>>>();

        this.onActiveCellChanged = new EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>();
        this.onActiveCellPositionChanged = new EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>();
        this.onSort = new EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>();
        this.onSorted = new EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>();
        this.onBeforeEditCell = new EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>(false);
        this.onCellChange = new EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>();
        this.onBeforeCellEditorDestroy = new EventEmitter<EventArgs<Slick.OnBeforeCellEditorDestroyEventArgs<any>>>();
        this.onViewportChanged = new EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>();
        this.onSelectedRowsChanged = new EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>();
        this.onHeaderCellRendered = new EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>();
        this.onFiltered = new EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>();
        this.appliedFilters = new EventEmitter<{ filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[] }>();
        this.onGrouping = new EventEmitter<EventArgs<OnGroupingEventArgs<any>>>();
        this.onAggregated = new EventEmitter<EventArgs<OnGroupingEventArgs<any>>>();
        //this.onInitialized = new EventEmitter<EventArgs<Slick.Grid<any>>>();
        this.onColumnsResized = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();
        this.onValidatorError = new EventEmitter<EventArgs<Slick.OnValidationErrorEventArgs<any>>>();
        this.onHeaderContextMenu = new EventEmitter<EventArgs<Slick.OnHeaderContextMenuEventArgs<any>>>();
        this.onContextMenu = new EventEmitter<EventArgs<Slick.OnContextMenuEventArgs<any>>>();
        this.onMouseEnter = new EventEmitter<EventArgs<Slick.OnMouseEnterEventArgs<any>>>();
        this.onMouseLeave = new EventEmitter<EventArgs<Slick.OnMouseLeaveEventArgs<any>>>();
        this.onDragInit = new EventEmitter<EventArgs<Slick.OnDragInitEventArgs<any>>>();
        this.onDragStart = new EventEmitter<EventArgs<Slick.OnDragStartEventArgs<any>>>();
        this.onDrag = new EventEmitter<EventArgs<Slick.OnDragEventArgs<any>>>();
        this.onDragEnd = new EventEmitter<EventArgs<Slick.OnDragEndEventArgs<any>>>();
        this.onScroll = new EventEmitter<EventArgs<Slick.OnScrollEventArgs<any>>>();
        this.onBeforeDestroy = new EventEmitter<EventArgs<Slick.OnBeforeDestroyEventArgs<any>>>();
        this.onReady = new EventEmitter<boolean>();
        this.onDestroy = new EventEmitter<boolean>();
        this.selectAllEm = new EventEmitter<boolean>();
        //this.onColumnsReordered = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();

        this.filteredColumns = [];
        this.zoomFilteredColumns = [];
        this.helper = new StocksHelper();
        this.filterHelper = new SlickGridFilterHelper();
        this.unListSorter = new DataSorter<any>();
        // this.translates = {NoData: 'No data'};
        this.columnsAll = [];
        this.gridGUID = this.helper.generateGUID();
        this.menuPosition = {top: 0, left: 0};

        this.unListSorter.customComparers['name'] = (a, b) => {
            const A = a.value, B = b.value;
            return A === B ? 0 : A > B ? 1 : -1;
        };

        //this.translateService.use(sessionStorage.getItem('userLocale'));
        //console.log(sessionStorage.getItem('userLocale'));
    }

    @ViewChild('grid')
    public gridRef: ElementRef;

    @ViewChild('gridMenu')
    private gridMenu: ElementRef;

    @ViewChild('gridMenuWrp')
    public gridMenuWrp: ElementRef;

    //private gridWidth: number;
    //@Input()
    //set width(value: number) {
    //    if (value)
    //        this.gridWidth = value;
    //}
    //get width(): number {
    //    return this.gridWidth;
    //}

    //private gridHeight: number;
    //@Input()
    //set height(value: number) {
    //    if (value)
    //        this.gridHeight = value;
    //}
    //get height(): number {
    //    return this.gridHeight;
    //}

    private dataView: Slick.Data.DataView<any>;
    private data: Slick.Data.DataView<any> | any[];

    //# set data to grid
    @Input('data')
    set dataInput(data: Slick.Data.DataView<any> | any[]){
        this.removeDataViewListeners();

        this.data = data || [];
        if (this.data instanceof Slick.Data.DataView){
            this.dataView = this.data as Slick.Data.DataView<any>;
        } else{
            this.dataView = new Slick.Data.DataView<any>();
        }

        this.dataView.onRowCountChanged.subscribe(this.onDataViewRowCountChanged);
        this.dataView.onRowsChanged.subscribe(this.onDataViewRowsChanged);

        if (!this.grid)
            return;

        if (this.data instanceof Slick.Data.DataView)
            this.grid.setData(this.data as Slick.Data.DataView<any>, true);
        else
            this.grid.setData(this.data as any[], true);
        this.grid.render();
        this.toggleHideGridFunc();



    }

    // private renderedColumns: Slick.OnHeaderCellRenderedEventArgs<any>[];
    public columns: Slick.Column<any>[];
    private _columnsAll: Slick.Column<any>[];

    set columnsAll(val: Slick.Column<any>[]){
        this._columnsAll = val;
    }

    get columnsAll(): Slick.Column<any>[] {
        return this._columnsAll;
    }

    //# set columns to grid
    @Input('columns')
    set columnsInput(columns: Slick.Column<any>[]){
        const setColumns = (): void => {
            this.columns = columns;
            this.columnsAll = columns;
            //
            // this.columns = this.columnsAll.filter(c => !c.disabled);
            // console.log(this.columnsAll, this.columns)
            // this.columns.push({ id: 'id', field: 'id', name: '', sortable: true, width: 0, minWidth: 0, maxWidth: 0, cssClass: 'd-none-grid', headerCssClass: 'd-none-grid'});
            if (this.grid)
                this.setColumns(this.columnsAll);
            if (this.filteredColumns && this.filteredColumns.length)
                this.filteredColumns = [];
        };

        if (!columns || !columns.length){
            columns = [];
            setColumns();
            return;
        }

        setColumns();

        //# translate columns names
        this.translateService.get(columns.map(c => c.name)).subscribe(names => {
            columns.forEach(c => c.name = names[c.name]);
            setColumns();
        });
    }

    private options: Slick.GridOptions<any>;

    //# set options for grid
    @Input('options')
    set optionsInput(options: Slick.GridOptions<any>){
        this.options = options || {};
        if (this.grid){
            this.grid.setOptions(this.options);
        }
    }

    private css: string[];

    //# add classes to grid
    @Input()
    set cssClasses(css: string[]){
        if (!this.gridRef){
            this.css = css;
            return;
        }

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.remove(c));

        this.css = css;

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.add(c));
    }

    private cellStyles: { [key: string]: Slick.CellCssStylesHash }

    //# set styles for grid cells
    @Input()
    set cellCssStyles(value: { [key: string]: Slick.CellCssStylesHash }){

        this.removeCellStyles();

        this.cellStyles = value;

        this.setCellStyles();
    }

    private selection: Slick.SelectionModel<any, Slick.Range[]>;

    //# set selection model for grid
    @Input()
    set selectionModel(value: Slick.SelectionModel<any, Slick.Range[]>){
        this.selection = value;

        if (this.grid)
            this.grid.setSelectionModel(value);
    }

    private sorter: IDataSorter<any>;

    //# set sorter, use when sort data in grid
    @Input()
    set dataSorter(value: IDataSorter<any>){
        if (value){
            this.sorter = value;
        }

    }

    //# deny, add aggregation from column header
    @Input()
    private denyAggregation?: boolean;

    //# deny filters from column header
    @Input()
    private denyFilters?: boolean;

    //# function for custom sort after load properties
    @Input()
    private sortColumns?: (columns: any[]) => void;

    //# deny, add grouping and aggregation from column header
    @Input()
    private denyGrouping?: boolean;

    //# deny, add grouping and aggregation from column header
    @Input()
    public filtersCssClass?: string[];

    //# filters behavior
    @Input()
    private filterBehaviorIn?: HTMLElement;

    //# filters behavior
    @Input()
    private test?: any;

    @Input()
    private cancelSort?: boolean;

    @Input()
    private updateRowDimensions?: boolean;

    /**
     * generate menu for display columns
    */
    @Input()
    private genHeaderMenu: boolean;

    @Input()
    private manualEllipsis?: { paddingWidth: number, strings: number, fontSize: number};

    @Input()
    private customRowHeight?: { fontName: string, fontSize: string };

    @Input()
    public setCustomRowHeight?: boolean;

    private _showNoData: boolean;

    private _showCustomMsg: string;

    //# show nodata message if grid not contains data
    @Input()
    private set showNoData(val: boolean){
        // console.log(val, this.dataView.getItems().length, 'showNoData')
        this._showNoData = val
    };

    private get showNoData(): boolean{
        return this._showNoData;
    };

    @Input()
    public set showCustomMsg(val: string){
        this._showCustomMsg = val;
        this.resizeGridViewChecked = true;
        if (!this._showCustomMsg){
            this.updateEllipsis();
        }
    };

    public get showCustomMsg(): string{
        return this._showCustomMsg;
    };

    private propsName: ModuleTableName;

    //# set grip properties, by this data we download grid properties (columns width and order)
    @Input('propsName')
    set setPropsName(val: ModuleTableName){
        if (val && val.moduleName && val.tableName){
            this.propsName = val;
            this.setSlickGridProps();
        } else{
            this.propsName = null;
        }
    }

    private grid: Slick.Grid<any>;
    private helper: StocksHelper;
    public filterHelper: SlickGridFilterHelper;
    private pluginsToRegister: Slick.Plugin<any>[];
    private gridInitiating: boolean;
    private _hideGrid: boolean;

    public set hideGrid(val: boolean){
        // console.log(val, this.dataView.getItems().length, 'hideGrid')
        this._hideGrid = val;
        if (!this._hideGrid){
            this.updateEllipsis();
        }
    };

    public get hideGrid(): boolean{
        return this._hideGrid;
    };

    public translates: TranslateType;
    private slickGridProp: SlickGridColumns[];
    private resizeGridViewChecked: boolean;
    public universalData: SlickFilterItem[];
    public universalSettings: UniversalListSettings;
    public universalBTN: HTMLElement;
    public updatePopper: number;
    private dropDownPopper: Popper;
    public unColSettings: ISlickGridColumn<any>[];
    public applyFilter: (event: { data: any[], selected: any[] }) => void;
    public showUnList: boolean;
    public gridGUID: string;
    public unListSorter: DataSorter<any>;
    public filterBehavior: HTMLElement;
    public filterBoundary: HTMLElement;
    private checkBoxHeader: HTMLInputElement;
    private fontSize: FontSize;
    private scrollTimer: Timer;
    private resizeTimer: Timer;
    public showMenu: boolean;
    public columnId: string;
    public hiddenColumns: Slick.Column<any>[];
    public viewColumns: Slick.Column<any>[];
    public menuPosition: {left: number, top: number};
    public popperUpdated: boolean;
    private popper: Popper;

    //# standart grid events reemitted from component

    //# emit click event, if make click on grid
    @Output()
    private readonly onClick: EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>;

    //# emit click event, if double click on grid
    @Output()
    private readonly onDblClick: EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>;

    //# emit KeyDown event, if KeyDown click on grid
    @Output()
    private readonly onKeyDown: EventEmitter<EventArgs<Slick.OnKeyDownEventArgs<any>>>;

    //# emit event, if Active Cell Changed in grid
    @Output()
    private readonly onActiveCellChanged: EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>;

    //#
    @Output()
    private readonly onActiveCellPositionChanged: EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>;

    @Output()
    private readonly onSort: EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>;

    @Output()
    private readonly onSorted: EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>;

    @Output()
    private readonly onBeforeEditCell: EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>;

    @Output()
    private readonly onCellChange: EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>;

    @Output()
    private readonly onBeforeCellEditorDestroy: EventEmitter<EventArgs<Slick.OnBeforeCellEditorDestroyEventArgs<any>>>;

    @Output()
    private readonly onViewportChanged: EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>;

    @Output()
    private readonly onSelectedRowsChanged: EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>;

    @Output()
    private readonly onHeaderCellRendered: EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>;

    @Output()
    public readonly onFiltered: EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>;

    @Output()
    private readonly appliedFilters: EventEmitter<{ filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[] }>;

    @Output()
    private readonly onGrouping: EventEmitter<EventArgs<OnGroupingEventArgs<any>>>;

    @Output()
    private readonly onAggregated: EventEmitter<EventArgs<OnGroupingEventArgs<any>>>;

    @Output()
    private readonly onColumnsResized: EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>;

    @Output()
    private readonly onValidatorError: EventEmitter<EventArgs<Slick.OnValidationErrorEventArgs<any>>>;

    @Output()
    private readonly onHeaderContextMenu: EventEmitter<EventArgs<Slick.OnHeaderContextMenuEventArgs<any>>>;

    @Output()
    private readonly onContextMenu: EventEmitter<EventArgs<Slick.OnContextMenuEventArgs<any>>>;

    @Output()
    private readonly onMouseEnter: EventEmitter<EventArgs<Slick.OnMouseEnterEventArgs<any>>>;

    @Output()
    private readonly onMouseLeave: EventEmitter<EventArgs<Slick.OnMouseLeaveEventArgs<any>>>;

    @Output()
    private readonly onDragInit: EventEmitter<EventArgs<Slick.OnDragInitEventArgs<any>>>;

    @Output()
    private readonly onDragStart: EventEmitter<EventArgs<Slick.OnDragStartEventArgs<any>>>;

    @Output()
    private readonly onDrag: EventEmitter<EventArgs<Slick.OnDragEventArgs<any>>>;

    @Output()
    private readonly onDragEnd: EventEmitter<EventArgs<Slick.OnDragEndEventArgs<any>>>;

    @Output()
    private readonly onScroll: EventEmitter<EventArgs<Slick.OnScrollEventArgs<any>>>;

    @Output()
    private readonly onBeforeDestroy: EventEmitter<EventArgs<Slick.OnBeforeDestroyEventArgs<any>>>;

    @Output()
    private readonly onReady: EventEmitter<boolean>;

    @Output()
    private readonly onDestroy: EventEmitter<boolean>;

    @Output('selectAll')
    private readonly selectAllEm: EventEmitter<boolean>;

    /*@Output()
    private readonly onColumnsReordered: EventEmitter<EventArgs<Slick.OnColumnsReorderedEventArgs<any>>>;*/

    //@Output()
    //private readonly onInitialized: EventEmitter<EventArgs<Slick.Grid<any>>>;

    get htmlElement(): HTMLElement{
        return this.elementRef.nativeElement;
    }

    private filteredColumns: string[];

    public zoomFilteredColumns: string[];

    ngOnChanges(changes: SimpleChanges): void{

        if (changes['setCustomRowHeight'] && changes['setCustomRowHeight'].firstChange === true){
            return;
        } else if (changes['setCustomRowHeight']) {
            // console.log(changes, 'SimpleChanges')
            this.setCustomRowHeight = changes['setCustomRowHeight'].currentValue;
        }
    }

    async ngAfterViewChecked(): Promise<void>{

        if (this.resizeGridViewChecked){
            //console.log('resizeGridViewChecked')
            if (this.grid){
                this.resizeGridViewChecked = false;
                this.grid.resizeCanvas();
            }
        }

        if (this.showMenu && !this.popperUpdated){
            this.popperUpdated = true;
            this.popper ? this.popper.update() : null;
        }

        //# initialise grid
        if (this.grid || this.gridInitiating)
            return;

        this.gridInitiating = true;

        this.cssClasses = this.css;

        this.translates = await this.translateService.get([
            'NoData', 'RowsForOrder', 'NoSelectedFields',
            'All', 'Blank_Are', 'NonBlank_Are', 'Apply', 'Cancel', 'Clear', 'Selected', 'Between', 'Filter',
            'Avg', 'Sum', 'Min', 'Max', 'Grouping', 'Aggregation', 'SelectAll'
        ]).toPromise();

        if (this.customRowHeight){
            try{
                let loadRes = await this.common.getFontDimensions(this.customRowHeight.fontName, this.customRowHeight.fontSize).toPromise();
                // console.log(loadRes, 'getFontDimensions')
                if (loadRes.success && loadRes.data){
                    this.fontSize = JSON.parse(loadRes.data);

                } else {
                    this.fontSize = this.generateFontSize(this.customRowHeight.fontName, this.customRowHeight.fontSize);
                    // console.log(this.fontSize, 'generateFontSize')
                    this.common.saveFontDimensions(this.fontSize).subscribe(r => r);
                }
            } catch (e){

            }
        }

        this.grid = new Slick.Grid(this.gridRef.nativeElement, this.data, [], this.options);
        //console.log(this.options.frozenColumn, this.test, 'init grid')
        // this.helper.wait(() => this.grid.setOptions(this.options));
        this.grid.onClick.subscribe((e, data) => {
            MainHelper.stWait(() => this.showMenu = false);
            this.onClick.emit(new EventArgs(e, data));
        });
        this.grid.onDblClick.subscribe((e, data) => this.onDblClick.emit(new EventArgs(e, data)));
        this.grid.onKeyDown.subscribe((e, data) => this.onKeyDown.emit(new EventArgs(e, data)));
        this.grid.onActiveCellChanged.subscribe((e, data) => this.onActiveCellChanged.emit(new EventArgs(e, data)));
        this.grid.onActiveCellPositionChanged.subscribe((e, data) => this.onActiveCellPositionChanged.emit(new EventArgs(e, data)));
        //this.grid.onSort.subscribe((e, data) => this.onSort.emit(new EventArgs(e, data)));
        this.grid.onSort.subscribe((e, data) => {
            this.setCustomRowHeight && this.removeEmptyRows();
            this.sortData(e, data)
            this.setCustomRowHeight && this.addEmptyRows();
        });
        this.grid.onBeforeEditCell.subscribe((e, data) => {
            try{
                this.helper.tooltipFuncGridRem(this.grid.getCellNode(data.row, data.cell));
            } catch (e){

            }

            this.onBeforeEditCell.emit(new EventArgs(e, data));
            return !e.isPropagationStopped();
        });
        this.grid.onBeforeCellEditorDestroy.subscribe((e, data) => this.onBeforeCellEditorDestroy.emit(new EventArgs(e, data)));
        this.grid.onCellChange.subscribe((e, data) => this.onCellChange.emit(new EventArgs(e, data)));
        this.grid.onViewportChanged.subscribe((e, data) => this.onViewportChanged.emit(new EventArgs(e, data)));
        this.grid.onSelectedRowsChanged.subscribe((e, data) => this.onSelectedRowsChanged.emit(new EventArgs(e, data)));
        this.grid.onHeaderCellRendered.subscribe(this.onGridHeaderCellRendered);
        this.grid.onHeaderCellRendered.subscribe((e, data) => this.onHeaderCellRendered.emit(new EventArgs(e, data)));
        this.grid.onHeaderContextMenu.subscribe((e, data) => {
            let ev = new EventArgs(e, data);
            if (this.genHeaderMenu){
                this.onGridHeader(ev);
            }

            this.onHeaderContextMenu.emit(ev);
        });
        this.grid.onContextMenu.subscribe((e, data) => this.onContextMenu.emit(new EventArgs(e, data)));

        this.grid.onMouseEnter.subscribe((e, data) => {
            this.mouseEnter(new EventArgs(e, data));
            this.onMouseEnter.emit(new EventArgs(e, data));
        });

        this.grid.onMouseLeave.subscribe((e, data) => {
            this.mouseLeave(new EventArgs(e, data));
            this.onMouseLeave.emit(new EventArgs(e, data));
        });

        this.grid.onDragInit.subscribe((e, data) => this.onDragInit.emit(new EventArgs(e, data)));
        this.grid.onScroll.subscribe((e, data) => {
            if (!this.scrollTimer){
                this.scrollTimer = setTimeout(() => {
                    clearTimeout(this.scrollTimer);
                    this.scrollTimer = null;
                    $(`.${this.gridGUID}-grid-gen-tooltip`).tooltip('dispose');
                }, 50)
            }


            // console.log($(`.${this.gridGUID}-grid-gen-tooltip`), 'grid scroll')
            this.onScroll.emit(new EventArgs(e, data));

        });
        this.grid.onDragStart.subscribe((e, data) => this.onDragStart.emit(new EventArgs(e, data)));
        this.grid.onDrag.subscribe((e, data) => this.onDrag.emit(new EventArgs(e, data)));
        this.grid.onDragEnd.subscribe((e, data) => this.onDragEnd.emit(new EventArgs(e, data)));
        this.grid.onColumnsResized.subscribe((e, data: any) => {
            const column = this.columns.find(c => c.id === data.triggeredByColumn);
            let headerCell = $('.' + this.gridGUID + '_' + (column.regColId ? column.regColId : column.id))[0];



            /*if (this.resizeTimer){
                clearTimeout(this.resizeTimer);
                this.resizeTimer = null;
            }
            this.resizeTimer = setTimeout(() => {*/

                this.manualEllipsis
                    ? this.manualEllipsisFunc(data.triggeredByColumn, null, true)
                    : this.addColumnTooltip(column, headerCell, true);
                this.setCustomRowHeight && this.removeEmptyRows();
                this.onColumnResizeFunc(e, data);
                this.setCustomRowHeight && this.setRowHeight();
                clearTimeout(this.resizeTimer);
                this.resizeTimer = null;

            // }, 150)

        });
        this.grid.onColumnsReordered.subscribe((e, data) => {
            const indexMap = new Map<string, number>(this.grid.getColumns().map((o, i) => [o.id, i] as [string, number]));
            this.columnsAll.sort((a, b) =>
                indexMap.get(a.id) - indexMap.get(b.id)
            );

            if (this.checkBoxHeader){
                this.checkAllSelect();
            }
            this.onColumnResizeFunc(e, data)
        });
        this.grid.onValidationError.subscribe((e, data) => this.onValidatorError.emit(new EventArgs(e, data)));

        this.grid.onBeforeDestroy.subscribe((e, data) => this.onBeforeDestroy.emit(new EventArgs<Slick.OnBeforeDestroyEventArgs<any>>(e, data)))

        this.setColumns(this.columnsAll);

        if (this.selection){
            this.grid.setSelectionModel(this.selection);
            let cellExternalCopyManagerOptions = {
                readOnlyMode: true,
                includeHeaderWhenCopying: false,
                dataItemColumnValueExtractor: (item, columnDef): string => columnDef.formatter ? columnDef.formatter(null, null, item[columnDef.field], columnDef, item) : item[columnDef.field]
            };
            this.grid.registerPlugin(new Slick['CellExternalCopyManager'](cellExternalCopyManagerOptions));
        }

        this.grid.registerPlugin(new Slick['AutoColumnSize']());

        this.setCellStyles();
        this.registerPlugins();
        this.toggleHideGridFunc();

        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            // let headers = document.getElementsByClassName('slick-header-column');
            // for (let i = 0; i < headers.length; i++){
            //     headers[i].classList.add('box-sizing-border-box')
            // }
        }

        this.universalData = [];
        this.universalSettings = new UniversalListSettings('1', '1');
        this.updatePopper = 0;

        let unGenerator = new ColumnsGenerator<SlickFilterItem>(this.translateService, this.renderer, this.elementRef),
            unColSettings = [
                new ColumnSettingsBase(1, 'name', 'search-string', null, 'Name', 'string', 1, 150, 10)
            ]
        unColSettings[0].tooltip = 'auto';
        this.unColSettings = await unGenerator.columnsGenerate([], unColSettings, true);

        this.filterBehavior = this.filterBehaviorIn ? this.filterBehaviorIn : this.gridRef.nativeElement.querySelector('.slick-pane.slick-pane-top');

        if (this.options.boundary){
            this.filterBoundary = document.querySelector(this.options.boundary);
        }

        this.helper.wait(() => this.onReady.emit(true), 50);

        // For change in node modules

        /*var header = $("<div class='ui-state-default slick-header-column' />")
            .html("<span class='slick-column-name'>" + m.name + "</span>")
            .outerWidth(m.width - headerColumnWidthDiff)
            .attr("id", "" + uid + m.id)
            .attr("title", m.toolTip || "")
            .data("column", m)
            .addClass(m.headerCssClass || "")
            .appendTo($headers);*/

        //this.onInitialized.emit(new EventArgs(new Slick.EventData(), this.grid));
        this.gridInitiating = false;
        this.resizeGridViewChecked = true;
    }

    ngOnDestroy(): void{
        this.destroyGrid();
    }

    destroyGrid = (): void => {
        if (!this.grid)
            return;

        this.removeDataViewListeners();

        this.grid.destroy();
        this.grid = null;
        this.onDestroy.emit(true);
    }

    //# Resize grid when dimensions of window change
    @HostListener('window:resize')
    resizeGrid = (): void => {
        if (this.grid){
            this.grid.resizeCanvas();
            this.dropDownPopper && this.dropDownPopper.update();
            this.helper.wait(() => this.updatePopper = Math.random() * 100);
        }

    }

    //# initialise angular editor component
    initializeAngularEditor = (editor: IAngularEditor): void => {
        editor.initialize(this.appRef, this.resolver, this.injector, this.renderer);
    }

    //# if columns changed width or order emit event
    onColumnResizeFunc = (e, data): void =>{
        let event = new EventArgs(e, data);
        this.onColumnsResized.emit(event);

        if (!this.propsName){
            return
        }

        // console.log(event, this.propsName.moduleName, this.propsName.tableName, this.slickGridProp, 'onColunmResizeFunc')

        this.commonData.saveSlickGridProp(this, this.propsName.moduleName, this.propsName.tableName, this.slickGridProp, this.propsName.fresh);
    }


    //# throw standard methods
    getActiveCell = (): Slick.Cell => {
        return this.grid.getActiveCell();
    }

    //# throw standard methods
    setActiveCell = (row: number, cell: number, suppressActiveCellChangedEvent?: boolean): void => {
        (this.grid as any).setActiveCell(row, cell, null, null, suppressActiveCellChangedEvent);
    }

    //# throw standard methods
    scrollCellIntoView = (row: number, cell: number, doPaging: boolean): void => {
        this.grid.scrollCellIntoView(row, cell, doPaging);
    }

    //# throw standard methods
    getCellNode = (row: number, cell: number): HTMLElement => {
        return this.grid ? this.grid.getCellNode(row, cell) : null;
    }

    //# add plugin to list, register it
    registerPlugin = (plugin: Slick.Plugin<any>): void => {
        if (!this.pluginsToRegister)
            this.pluginsToRegister = [];

        this.pluginsToRegister.push(plugin);
        this.registerPlugins();
    }

    public getCanvasNode = (): HTMLCanvasElement => {
        return this.grid.getCanvasNode()
    }

    //# set grid options
    setOptions = (options: Slick.GridOptions<any>): void => {
        this.optionsInput = options;
        //this.grid.setOptions(options);

    }

    //# freeze columns in grid
    setFreezeColumns = (qnt: number): void => {
        // this.grid.setOptions({ 'frozenColumn': qnt - 1 });

        this.options.frozenColumn = qnt - 1;
        this.optionsInput = this.options;
        this.columns.forEach((item, i) => {
            if (qnt - 1 >= i){
                // item.headerCssClass = 'frozen'
                // item.cssClass = 'frozen'
            } else{
                // item.headerCssClass = ''
                // item.cssClass = ''
            }
        })
        this.setColumns(this.columnsAll);
        this.resizeGridViewChecked = true;


        //this.resizeGrid();
        //this.grid.setOptions(options);

    }

    //# throw standard methods
    getOptions = (): Slick.GridOptions<any> => {
        return this.grid.getOptions();

    }

    //# get cell editor
    getCellEditor = (): any => {
        return this.grid.getCellEditor();
    }

    //# set focus for grid
    setFocus = (): void => {
        this.grid.getCanvasNode().focus();

    }

    //# set sort columns for grid
    setSortColumns = (cols: { columnId: string; sortAsc: boolean }[]): void => {
        this.grid.setSortColumns(cols);

    }

    //# throw standard methods
    focus = (): void => {
        this.grid.focus();
    }

    //# throw standard methods
    getViewport = (): any => {
        return this.grid.getViewport();
    }

    //# throw standard methods
    invalidateAllRows = (options: Slick.GridOptions<any>): void => {
        this.grid.invalidateAllRows();
    }

    //# throw standard methods
    getColumnIndex = (id: string): number => {
        return this.grid.getColumnIndex(id);
    }

    //# throw standard methods
    editActiveCell = (editor?: Slick.Editors.Editor<any>): void => {
        this.grid.editActiveCell(editor);
    }

    //# throw standard methods
    invalidate = (): void => {
        if (this.grid){
            this.grid.invalidate();
        }
    }

    //# throw standard methods
    setCellCssStyles = (key: string, hash: CellCssStylesHash): void => {
        this.grid.setCellCssStyles(key, hash);
    }

    //# throw standard methods
    getCellCssStyles = (key: string): CellCssStylesHash => {
        return this.grid.getCellCssStyles(key)
    }

    //# throw standard methods
    invalidateRow = (row: number): void => {
        this.grid.invalidateRow(row);
    }

    //# throw standard methods
    render = (): void => {
        this.grid.render();
    }

    //# throw standard methods
    resizeCanvas = (): void => {
        this.grid.resizeCanvas();
    }

    //# throw standard methods
    setColumns = (columns): void => {
        this.columnsAll = columns;
        this.columns = this.columnsAll.filter(c => !c.disabled);
        if (this.grid){
            //this.renderedColumns = [];
            //console.trace(columns, 'set columns')
            this.grid.setColumns(this.columns);
        }
    }

    /**
     * hide opened dropdown filters and number filter
     */
    hideDropdownFilters = (): void => {
        this.applyFilter && this.applyFilter(null);
        //TODO hide number filter and aggregation list

    }

    private readonly mouseEnter = (e: EventArgs<Slick.OnMouseEnterEventArgs<any>>): void => {
        let cell = this.grid.getCellFromEvent((e.event as any).originalEvent);
        if (cell && this.columns[cell.cell] && this.columns[cell.cell].tooltip){
            let node = this.grid.getCellNode(cell.row, cell.cell),
                $node = $(node),
                text;
            text = $.trim($node.text());

            if (this.grid.getCellEditor()){
                if ( (this.grid.getCellEditor() as any).args.container.isEqualNode(node))
                    return
            }


            let $found = $node.find('.format-edit-cell');

            if ($found.length){
                let $foundSpan = $found.find('span')
                if ($foundSpan.length){
                    $node = $($foundSpan[0]);
                    node = $foundSpan[0];
                    text = $.trim($node.text());
                }
            }

            const addTooltip = (): void => {
                text && this.helper.tooltipFuncGridAdd(node, `#${this.gridGUID}`, text, this.gridRef.nativeElement.offsetWidth - 20, this.gridGUID);
            }

            const removeTooltip = (): void => {
                $node.tooltip('dispose');
            }

            switch (this.columns[cell.cell].tooltip){
                case 'show':
                    addTooltip()
                    break;
                case 'auto':
                    $node.innerWidth() + 0.5 < node.scrollWidth
                        ? addTooltip()
                        : removeTooltip()
                    break;
            }
        }
    }

    private readonly mouseLeave = (e: EventArgs<Slick.OnMouseLeaveEventArgs<any>>): void => {
        let cell = this.grid.getCellFromEvent((e.event as any).originalEvent);
        if (cell){
            let node = this.grid.getCellNode(cell.row, cell.cell),
                $node = $(node),
                $found = $node.find('.format-edit-cell');

            if ($found.length){
                let $foundSpan = $found.find('span')
                if ($foundSpan.length){
                    $node = $($foundSpan[0]);
                    node = $foundSpan[0];
                }
            }
            this.helper.tooltipFuncGridRem(node);
        }

    }

    //# remove current filters from list
    clearFilters = (ids: string[] = null, refreshColumns: boolean = true): void => {
        if (ids){
            let idx: number[] = [];
            let idx2: number[] = [];

            ids.forEach(item => {
                this.filteredColumns.forEach((inItem, i) => {
                    if (inItem === item){
                        idx.push(i);
                    }
                });

                this.filterHelper.filters.forEach((inItem, i) => {
                    if (inItem.column.field === item){
                        idx2.push(i);
                    }
                });
            });

            idx.reverse();
            idx2.reverse();
            idx.forEach(item => this.filteredColumns.splice(item, 1));
            idx2.forEach(item => this.filterHelper.filters.splice(item, 1));

        } else{
            this.filteredColumns.length = 0;
            this.filterHelper.filters.length = 0;
        }

        refreshColumns && this.setColumns(this.columnsAll);
        this.setCustomRowHeight && this.removeEmptyRows();
        this.dataView.refresh();
        this.setCustomRowHeight && this.addEmptyRows();
    }

    //# add filters to slickgrid
    addFilters = (filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[]): void => {
        if (filteredColumns && filteredColumns.length > 0 && filters && filters.length > 0){
            //console.log(filters, 'addFilters')
            // this.filteredColumns = filters.map(item => item.column.field);
            this.filteredColumns = filteredColumns;

            this.filterHelper.filters = filters;
            // console.log(this.filterHelper.filters)
            // refreshColumns && this.setColumns(this.columns);
            this.setColumns(this.columnsAll);
            this.setCustomRowHeight && this.removeEmptyRows();
            this.dataView.refresh();
            this.setCustomRowHeight && this.addEmptyRows();
        }
    }

    //# get filters from slickgrid
    getFilters = (): {filteredColumns: string[], filters: OnDropdownFilteredEventArgs<any>[] } => {
        return {filteredColumns: this.filteredColumns, filters: this.filterHelper.filters};
    }

    getEditorLock = (): EditorLock<any> => {
        return this.grid.getEditorLock()
    }

    //# throw standard methods
    setSortColumn = (colId: string, asc: boolean): void => {
        this.grid.setSortColumn(colId, asc);
    }

    //# throw standard methods
    autosizeColumns = (columns): void => {
        this.grid.autosizeColumns();
    }

    //# throw standard methods
    updateColumnHeader = (columnName: string): void => {
        this.grid.updateColumnHeader(columnName);
    }

    //# throw standard methods
    setHeaderRowVisibility = (visible: boolean): void => {
        this.grid.setHeaderRowVisibility(visible);
    }

    //# throw standard methods
    getSelectedRows = (): number[] => {
        return this.grid.getSelectedRows();
    }

    //# throw standard methods
    setSelectedRows = (rows: number[]): void => {
        this.grid && this.grid.setSelectedRows(rows);
    }

    //# throw standard methods
    getRenderedRange = (viewportTop?: number, viewportLeft?: number): Slick.Viewport => {
        return this.grid.getRenderedRange(viewportTop, viewportLeft);
    }

    //# throw standard methods
    getDataItem = (index: number): any => {
        return this.grid.getDataItem(index);
    }

    //# throw standard methods
    getData = (): any => {
        return this.grid.getData();
    }

    //# throw standard methods
    updateRow = (row: number): void => {
        this.grid.updateRow(row);
    };

    //# throw standard methods
    getColumns = (): Slick.Column<any>[] => {
        return this.grid && this.grid.getColumns();
    };

    /**
     * Get all columns eve hidden
     */
    getAllColumns = (): Slick.Column<any>[] => {
        return this.columnsAll.map(c => c);
    };

    //# throw standard methods
    updateRowCount = (): void =>{
        this.grid && this.grid.updateRowCount();
    };

    //# throw standard methods
    scrollRowIntoView = (row: number, doPaging: boolean): void =>{
        this.grid && this.grid.scrollRowIntoView(row, doPaging);
    };

    //# throw standard methods
    resetActiveCell = (): void => {
        this.grid && this.grid.resetActiveCell();
    };

    //# throw standard methods
    getCellFromEvent = (e: any): any => {
        return this.grid.getCellFromEvent(e);
    };

    //# throw standard methods
    syncGridCellCssStyles = (key: string): void => {
        if (this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridCellCssStyles(this.grid, key);
    };

    //# throw standard methods
    syncGridSelection = (preserveHidden: boolean): void => {
        if (this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridSelection(this.grid, preserveHidden);
    };

    //# throw standard methods
    private setColumnsProps = (): void => {
        // this.commonData.setSlickGridProp([new GetSlickGridProp(this.columns, this.propsName.tableName)], this.slickGridProp);

        if (this.grid){
            // this.sortColumns ? this.sortColumns(this.columns) : null;
            // this.setColumns(this.columns);
        }
    };

    //# set groupings to grid
    // TODO
    public setGrouping = (groupings: Slick.Data.GroupingOptions<any>[]): void => {

        this.dataView.setGrouping(groupings);
        if (!groupings && !groupings.length){
            this.columns.forEach(item => {
                item.grouping.aggregated = false;
                item.grouping.disableAggr = true;
                item.grouping.aggregation = new AggregationSelector(item.id, item.name, new Aggregation(false, false, false, false));
            })
        }

        // if (this.grid){
        //     this.sortColumns ? this.sortColumns(this.columns) : null;
        //     this.setColumns(this.columns);
        // }
    };

    //# show viewGrid menu on right click mouse on viewGrid column header
    public onGridHeader = (args: any): void =>{
        args.event.originalEvent.preventDefault();
        args.event.originalEvent.stopPropagation();
        this.viewColumns = this.getColumns();
        this.hiddenColumns = this.getAllColumns().filter(c => c.disabled);

        if (args.data.column){
            this.columnId = args.data.column.id;
            this.menuPosition.left = args.event.originalEvent.clientX;
            this.menuPosition.top = args.event.originalEvent.clientY;
            this.showMenu = true;
            this.popperUpdated = false;

            //# create menu popper
            this.helper.wait(() => this.popper = this.helper.popperAdd(
                this.gridMenuWrp.nativeElement,
                this.gridMenu.nativeElement,
                document.body,
                'right',
                ['right', 'left'],
                false
            ));
        }
    };

    //# update columns in view or parameter grid
    public updateColumns(data: {command: string, columnId: string}){

        if (data){
            switch (data.command){
                case 'add':
                    this.addColumnToGrid(data);
                    break;
                case 'remove':
                    this.removeColumnFromGrid(data);
                    break;

            }
            if (this.propsName){
                this.commonData.saveSlickGridProp(this, this.propsName.moduleName, this.propsName.tableName, this.slickGridProp, this.propsName.fresh);
            } else {
                this.onColumnResizeFunc({}, {})
            }

            //this.updateColors();

            //this.updateColorsAfterView = true;
            //this.resizeGrid = true;
        }
    }

    //# add columns to view or parameter grid
    private addColumnToGrid = (data: { command: string, columnId: string }): void =>{
        let added: Slick.Column<any> = null;
        this.columnsAll.forEach((item, i, arr) =>{
            if (item.id === data.columnId){
                added = item;
                item.disabled = false;
                arr.splice(i, 1);
            }
        });


        if (added){
            this.grid.getColumns().forEach(c => this.columnsAll.forEach(ca =>{
                if (c.id === ca.id){ ca.width = c.width }
            }))
            this.columnsAll.forEach((item, i, arr) =>{
                if (this.columnId === item.id){
                    arr.splice(++i, 0, added);
                }
            });
            this.setColumns(this.columnsAll)
            console.log(added, 'added')
            //this.updateColumnsView = true;
            //this.updatePresetAfterView = true;
            //this.setGrouping = true;
            // this.updateGroupingList = true;
            //this.updateData = true;

            // this[data.grid.toLowerCase() + 'Grid'].setColumns(columnsSource);
        } else{
            console.error(data, 'addColumnToGrid')
        }

    };

    //# remove columns to view or parameter grid
    private removeColumnFromGrid = (data: { command: string, columnId: string }): void =>{
        let removed: Slick.Column<any> = null;
        this.columnsAll.forEach((item, i, arr) =>{
            if (data.columnId === item.id){
                removed = item;
                item.disabled = true;
                //arr.splice(i, 1);
            }
        });

        this.grid.getColumns().forEach(c => this.columnsAll.forEach(ca =>{
            if (c.id === ca.id){ ca.width = c.width }
        }))

        if (removed){
            let headerCell = $('.' + this.gridGUID + '_' + (removed.regColId ? removed.regColId : removed.id))[0];
            console.log(removed, 'remove')
            this.renderer.removeClass(headerCell, 'filtered');
            this.helper.remFromArrSimple(this.filteredColumns, data.columnId);
            if (removed.inputFilter){
                removed.inputFilter.type === 'number'
                    ? this.setInputFilterNumberData(removed, 4, 1, [null, null])
                    : this.setInputFilterData(removed, 3, null, [])
            } else if (removed.dropdownFilter){
                this.setDropdownFilterData(removed, 3, null, [])
            }

            if (removed.grouping && removed.grouping.grouped){
                removed.grouping.grouped = false;
                this.onGrouping.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(removed, 'remove')));
                if (removed.grouping.aggregated){
                    removed.grouping.aggregated = false;
                    removed.grouping.aggregation = null;
                    // aggregated ? renderer.addClass(headerCell, 'aggregated') : renderer.removeClass(headerCell, 'aggregated');
                    this.onAggregated.emit(new EventArgs(
                        new Slick.EventData(),
                        new OnGroupingEventArgs(
                            removed,
                            'remove',
                            [new AggregationSelector(removed.id, removed.name, new Aggregation(false, false, false, false))]
                        )));
                }
            }

            // this.updateAggregation('remove', [new AggregationSelector(removed.id, removed.name, new Aggregation(false, false, false, false))]);
            // this.updateGrouping('remove', [new ColumnSelector(removed.id, removed.name, true)]);
            //this.remCurrentFilter(removed.id);

            // this.updateColumnsView = true;
            // this.updatePresetAfterView = true;
            this.setColumns(this.columnsAll);
            // this[data.grid.toLowerCase() + 'Grid'].setColumns(columnsSource);
        }
    };

    //# load
    private setSlickGridProps = (): void => {
        //this.hideGrid = true;
        this.commonData.saveUserProp.getSlickGridProperties(this.propsName.moduleName, [this.propsName.tableName]).subscribe(prop => {
            this.slickGridProp = !prop.data ? [] : JSON.parse(prop.data);
            // this.customRowHeight && console.log(this.slickGridProp, 'setSlickGridProps')
            this.setColumnsProps();
        });
    };

    private toggleHideGridFunc = (): void => {
        this.helper.wait(() => {
            !this.dataView.getItems().length && this.showNoData
                ? this.hideGrid = true
                : this.hideGrid = false;
            this.resizeGridViewChecked = true;
        })
    }

    private removeDataViewListeners = (): void => {
        if (this.dataView){
            this.dataView.onRowCountChanged.unsubscribe(this.onDataViewRowCountChanged);
            this.dataView.onRowsChanged.unsubscribe(this.onDataViewRowsChanged);
        }
    };

    private removeCellStyles = (): void => {
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.removeCellCssStyles(key);
    };

    private setCellStyles = (): void => {
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.setCellCssStyles(key, this.cellStyles[key]);
    };

    private onDataViewRowCountChanged = (/*e: Slick.EventData, args: Slick.Data.OnRowCountChangedEventData*/): void => {
        this.grid && this.grid.updateRowCount();
        this.grid && this.grid.render();
    };

    private onDataViewRowsChanged = (e: Slick.EventData, args: Slick.Data.OnRowsChangedEventData): void => {
        if (this.test){
            console.log(args.rows, 'args.rows')
            //args.rows.forEach()
        }
        this.grid && this.grid.invalidateRows(args.rows);
        this.grid && this.grid.render();
        this.toggleHideGridFunc()
    };

    private registerPlugins = (): void => {
        if (!this.grid || !this.pluginsToRegister)
            return;

        this.pluginsToRegister.forEach(p => this.grid.registerPlugin(p));
        this.pluginsToRegister = null;
    };

    private sortData = (event: Slick.EventData | DOMEvent, args: Slick.OnSortEventArgs<any>): void => {

        if (this.onSort.observers.length > 0){
            this.onSort.emit(new EventArgs(event, args));
            return;
        }


        const sorter = this.sorter || new DataSorter<any>(this.translateService.currentLang);

        sorter.sort(args);

        this.onSorted.emit(new EventArgs(event, args));
    };

    //# custom selection model for universal list component
    //public customSelect: (data: SlickFilterItem[], filteredData: SlickFilterItem[], selected: SlickFilterItem[], row: SlickFilterItem, maxPosition: { position: number },  selectAll: boolean) => void;

    public customSelect = (data: SlickFilterItem[], filteredData: SlickFilterItem[], selected: SlickFilterItem[], row: SlickFilterItem, maxPosition: { position: number }, selectAll: boolean): void => {
        let idsToDelete = [];
        switch (row.rowType){
            case DropdownFilterType.NonBlank:
                data.forEach(item => {
                    if (item.rowType === DropdownFilterType.ByValue){
                        maxPosition.position = row.position = ++maxPosition.position;

                        if (!item.selected){
                            selected.push(item);
                        } else if (!row.selected){
                            idsToDelete.push(item.id);
                        }

                        item.selected = row.selected;
                    }
                });
                break;
            case DropdownFilterType.Blank:
                break;
            default:
                let notBlank = data.filter(i => i.rowType === DropdownFilterType.ByValue),
                    quantityNotBlank = notBlank.length,
                    selectedNotBlankQuantity = notBlank.filter(i => i.selected && i.rowType === DropdownFilterType.ByValue).length,
                    nonBlankRow = data.find(i => i.rowType === DropdownFilterType.NonBlank),
                    selectedNonBlankRow = selected.some(item => item.rowType === DropdownFilterType.NonBlank);


                if (nonBlankRow){
                    nonBlankRow.selected = quantityNotBlank === selectedNotBlankQuantity;

                    if (nonBlankRow.selected){
                        !selectedNonBlankRow && selected.push(nonBlankRow)
                    } else{
                        selectedNonBlankRow && this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank)
                    }
                }

                //this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank);
                break;
        }

        if (idsToDelete.length){
            let selectedObj = this.helper.arrToObj(selected, 'id');
            idsToDelete.forEach(item => {
                delete selectedObj[item];
            });

            selected.length = 0;

            for (let prop in selectedObj){
                selected.push(selectedObj[prop]);
            }

            let nonBlankRow = data.find(i => i.rowType === DropdownFilterType.NonBlank),
                selectedNonBlankRow = selected.some(item => item.rowType === DropdownFilterType.NonBlank);

            if (nonBlankRow && nonBlankRow.selected && !selectedNonBlankRow){
                selected.push(nonBlankRow)
            } else if (nonBlankRow && !nonBlankRow.selected && selectedNonBlankRow){
                this.helper.remFromArr(selected, 'rowType', DropdownFilterType.NonBlank)
            }

            selected.sort((a: SlickFilterItem, b: SlickFilterItem) => a.position - b.position);
        }
    };

    //# add blank, non-blank items to universal list
    private addBlankNonBlank = (filteredData: SlickFilterItem[], translates: TranslateType, hasNotEmptyData: boolean, first: boolean = false): void => {
        let blank,
            nonBlank,
            maxId = filteredData.length ? Math.max.apply(null, filteredData.map(item => item.id)) : 0;

        blank = new SlickFilterItem(maxId + 1, false, translates.Blank_Are, DropdownFilterType.Blank);
        blank.value = translates.Blank_Are;
        nonBlank = new SlickFilterItem(maxId + 2, false, translates.NonBlank_Are, DropdownFilterType.NonBlank);
        nonBlank.value = translates.NonBlank_Are;

        !first ? filteredData.push(blank) : filteredData.unshift(blank);

        hasNotEmptyData
            ? !first
                ? filteredData.push(nonBlank)
                : filteredData.unshift(nonBlank)
            : null;
    };

    //# define filter type
    public filterType = (data: SlickFilterItem[]): DropdownFilterType => {
        let all, blank, nonBlank, byValue;
        let type: DropdownFilterType = DropdownFilterType.None;
        data.forEach(item => {
            switch (item.rowType){
                case DropdownFilterType.All:
                    all = true;
                    break;
                case DropdownFilterType.Blank:
                    blank = true;
                    break;
                case DropdownFilterType.NonBlank:
                    nonBlank = true;
                    break;
                case DropdownFilterType.ByValue:
                    byValue = true;
                    break;
            }
        });

        if (all || (blank && nonBlank)){
            type = DropdownFilterType.All;
        } else if (byValue){
            type = DropdownFilterType.ByValue;
        } else if (blank){
            type = DropdownFilterType.Blank;
        } else if (nonBlank){
            type = DropdownFilterType.NonBlank;
        }

        return type;
    };

    //# add dropdown filter
    private setDropdownFilter = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void => {
        if (this.denyFilters){
            return;
        }

        const renderer = column.dropdownFilter.renderer;

        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        //# add button to column header
        const btn = renderer.createElement('button');
        //let rendered = column.dropdownFilter.rendered;
        renderer.addClass(btn, 'dropdown-toggle');
        renderer.addClass(btn, 'dropdown-filter-btn');
        renderer.addClass(btn, 'fa-solid');
        renderer.addClass(btn, 'fa-filter');
        renderer.appendChild(headerCell, btn);
        renderer.setAttribute(btn, 'title', translates.Filter);

        let dropdownVisible = false,
            selectedData: SlickFilterItem[] = this.getSelectedData(column);
        //selectedDataPrev: { type: DropdownFilterType, value: any, text: string }[] = [];

        const btnClick = (e?: MouseEvent): boolean => {
            if (e){
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            this.universalBTN = btn;
            if (dropdownVisible && this.showUnList){
                this.showUnList = dropdownVisible = false;
                this.addColumnTooltip(column, headerCell);
                return true;
            } else if (!dropdownVisible && this.showUnList){
                return false;
            }

            this.universalSettings = new UniversalListSettings('1', '1');
            this.universalSettings.showTitle = false;
            this.universalSettings.emitOnClose = true;
            this.universalSettings.applyOneClick = false;
            this.universalSettings.changeSizes = true;
            this.universalSettings.cloneIncomingData = true;
            this.universalSettings.showFooter = true;
            this.universalSettings.showSelectedList = false;
            this.universalSettings.showSearch = false;
            this.universalSettings.hideListenerOnDom = true;
            this.universalSettings.selectAllField = 'name';
            this.universalSettings.denyFilters = true;
            this.universalSettings.startHeight = 350;
            this.universalSettings.startWidth = 350;
            this.universalSettings.popper.behavior = ['left'];
            this.universalSettings.popper.placement = 'bottom-end';

            let selectedObj: { [key: number]: SlickFilterItem } = {};

            this.applyFilter = (event: { data: SlickFilterItem[], selected: SlickFilterItem[] }): void => {
                //hideDropdown();
                if (!event){
                    // this.helper.wait(() => this.showUnList = dropdownVisible = false);
                    this.showUnList = dropdownVisible = false;
                    this.addColumnTooltip(column, headerCell);
                    return;
                }

                selectedData.length = 0;

                let type = this.filterType(event.selected);
                if (type === DropdownFilterType.All){
                    event.data.forEach(item => selectedData.push(item));
                } else{
                    event.selected.forEach(item => selectedData.push(item));
                }

                const index = this.filteredColumns.indexOf(column.field);
                if (!selectedData.length){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                this.setDropdownFilterData(column, type, headerCell, selectedData)
                this.showUnList = dropdownVisible = false;
            };


            //appendDropdownItem(translates.All, () => selectAll());

            const sorter = new DataSorter();
            let hasEmpty = false,
                hasNotEmtyData = false;

            // let data = this.dataView.getItems();
            let filter = this.filterHelper.filters.find(item => item.column.field === column.field);
            if (filter){
                this.clearFilters([column.field], false)
            }
            let data = this.helper.getRowsFromGridAll(this.dataView);

            if (this.setCustomRowHeight){
                data = data.filter(d => !d.hideRow);
            }

            // console.log(filter, 'filtering');
            // console.log(data, 'filtering data');
            if (filter){
                this.filterHelper.filters.push(filter);
                this.filteredColumns.push(column.field);
                this.dataView.refresh();
            }

            if (column.dropdownFilter.sourceFilter != null)
                data = data.filter(i => column.dropdownFilter.sourceFilter(i));

            //# remove duplicated items
            let uniqueData = data.map(i => {
                return i[column.field] !== null || i[column.field] !== '' || typeof i[column.field] !== 'undefined' ? i[column.field] : null;
            });

            // console.log(this.helper.arrToObj(uniqueData.map(i => i)), 'uniqueData');

            //#add previous filtered items
            if (filter){
                //uniqueData = uniqueData.concat(filter.value.value)
                // console.log(filter.value, 'filter')
            }

            // console.log(this.helper.arrToObj(uniqueData.map(i => i)), 'uniqueData 111');

            let dataObj = this.helper._arrToObj(uniqueData);
            uniqueData = this.helper.objToArr(dataObj);

            // console.log(uniqueData.map(i => i), 'uniqueData 2')

            //# add items to filter list
            this.universalData = uniqueData.sort((a, b) => {
                const formatter = (column.dropdownFilter.sortFormatter || (v => v));
                return sorter.compare(formatter(a), formatter(b));
            })
                .map((item, i) => {
                    const value = item;
                    const text = column.dropdownFilter.displayFormatter != null ? column.dropdownFilter.displayFormatter(null, null, value) : value;

                    if (text){
                        let data = new SlickFilterItem(i + 1, false, text, DropdownFilterType.ByValue);
                        data.value = value;
                        hasNotEmtyData = true;
                        return data;
                    }

                    hasEmpty = true;
                    return null;
                }).filter(item => item);


            if (column.dropdownFilter.type && column.dropdownFilter.type === 'reverse'){
                this.universalData.reverse();
            }

            //# add empty not empty, non empty to list
            hasEmpty && this.addBlankNonBlank(this.universalData, translates, hasNotEmtyData);

            let isMoment: boolean;
            if (this.universalData.length){
                isMoment = this.universalData.some(item => moment.isMoment(item.value));
                // console.log(this.universalData, isMoment)
                selectedObj = isMoment
                    ? this.helper.arrToObjMoment(selectedData, 'value', 'format')
                    : this.helper.arrToObj(selectedData, 'value');
            }

            this.universalData.forEach(item => {
                let key: string = isMoment ? (item.value as Moment).format() : item.value as string;
                if (selectedObj[key]){
                    item.selected = selectedObj[key].selected;
                    item.position = selectedObj[key].position;
                }
            });

            this.universalData.sort((a: SlickFilterItem, b: SlickFilterItem) => b.position - a.position);

            this.showUnList = dropdownVisible = true;
            this.removeDescription(column, headerCell);
            return true;
        }

        //# when click on button render filter
        renderer.listen(btn, 'click', (e: MouseEvent) => {
            if (!btnClick(e)){
                this.helper.waitInterval(btnClick, 100);
            }
        });
    };

    /**
     * Generate events and emit after filter apply
     * @param column - slickgrid column
     * @param type - filterType
     * @param headerCell
     * @param selectedData
     */
    private readonly setDropdownFilterData = (column: ISlickGridColumn<any>, type: number, headerCell: HTMLElement, selectedData: any[]): void => {
        let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'dropdown', selectedData));
        this.setCustomRowHeight && this.removeEmptyRows();
        this.filterHelper.onGridFiltered(args);
        this.dataView.refresh();
        this.onFiltered.emit(args);
        this.appliedFilters.emit({filteredColumns: this.filteredColumns, filters: this.filterHelper.filters});
        this.checkAllSelect();
        if (headerCell){
            this.addColumnTooltip(column, headerCell);
        }
        this.setCustomRowHeight && this.addEmptyRows();
    }

    private getSelectedData = (column: ISlickGridColumn<any>): SlickFilterItem[] => {
        let selectedData: SlickFilterItem[] = [];
        if (this.filterHelper.filters && this.filterHelper.filters.length){
            this.filterHelper.filters.forEach(item => {
                if (item.column.field === column.field){
                    selectedData = item.value;
                }
            })
        }
        return selectedData;
    }

    //# set dropdown filter with search
    private setInputFilter = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void => {
        if (this.denyFilters){
            return;
        }

        const renderer = column.inputFilter.renderer;

        if (this.filteredColumns.indexOf(column.id) >= 0)
            renderer.addClass(headerCell, 'filtered');

        const btn = renderer.createElement('button');

        //# add button to column header
        renderer.addClass(btn, 'fa-solid');
        renderer.addClass(btn, 'fa-filter');
        renderer.addClass(btn, 'input-filter-btn');
        renderer.setAttribute(btn, 'title', translates.Filter);
        renderer.appendChild(headerCell, btn);

        let dropdownVisible = false;

        const selectedData: SlickFilterItem[] = this.getSelectedData(column);
        //# when click on button render filter

        const btnClick = (e?: MouseEvent): boolean => {
            if (e){
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            this.universalBTN = btn;
            if (dropdownVisible && this.showUnList){
                this.showUnList = dropdownVisible = false;
                this.addColumnTooltip(column, headerCell);
                return true;
            } else if (!dropdownVisible && this.showUnList){
                return false;
            }

            this.universalSettings = new UniversalListSettings('1', '1');
            this.universalSettings.showTitle = false;
            this.universalSettings.emitOnClose = true;
            this.universalSettings.applyOneClick = false;
            this.universalSettings.changeSizes = true;
            this.universalSettings.cloneIncomingData = true;
            this.universalSettings.showFooter = true;
            this.universalSettings.showSelectedList = true;
            this.universalSettings.showSearch = true;
            this.universalSettings.hideListenerOnDom = true;
            this.universalSettings.selectAllField = 'name';
            this.universalSettings.denyFilters = true;
            this.universalSettings.startHeight = 350;
            this.universalSettings.startWidth = 350;
            this.universalSettings.popper.behavior = ['left'];
            this.universalSettings.popper.placement = 'bottom-end';

            //this.customSelect = null;

            let uniqueData: string[],
                data: any[],
                selectedObj: { [key: number]: SlickFilterItem } = {},
                hasEmpty = false,
                hasNotEmtyData = false;


            //# remove duplicated items and refresh meta data
            let filter = this.filterHelper.filters.find(item => item.column.field === column.field);
            if (filter){
                this.clearFilters([column.field], false)
            }

            data = this.helper.getRowsFromGridAll(this.dataView);

            if (this.setCustomRowHeight){
                data = data.filter(d => !d.hideRow);
            }
            //console.log(selectedObj, 'selectedObj');
            //console.log(filter, 'filter');
            // console.log(data.map(i => i), 'data.length ');

            if (filter){
                this.filterHelper.filters.push(filter);
                this.filteredColumns.push(column.field);
                this.dataView.refresh();
            }
            if (column.inputFilter.sourceFilter != null)
                data = data.filter(i => column.inputFilter.sourceFilter(i));



            uniqueData = data.map(i => {
                return i[column.field] !== null || i[column.field] !== '' || typeof i[column.field] !== 'undefined' ? i[column.field] : null;
            });

            if (filter){
                //uniqueData = uniqueData.concat(filter.value)
            }

            let dataObj = this.helper._arrToObj(uniqueData);
            uniqueData = this.helper.objToArr(dataObj);

            if (column.inputFilter.toString){
                uniqueData.map(ud => ud ? ud.toString() : ud)
            }

            this.universalData = uniqueData.map((item, i) => {
                const value = item;
                let text = column.inputFilter.displayFormatter != null ? column.inputFilter.displayFormatter(null, null, value) : value;

                if (column.inputFilter.toString){
                    text = text ? text.toString() : text;
                }

                if (text){
                    let data = new SlickFilterItem(i + 1, false, text, DropdownFilterType.ByValue);
                    data.value = value;
                    hasNotEmtyData = true;
                    return data;
                }

                hasEmpty = true;
                return null;
                //return new SlickFilterItem(i+1, false, item, DropdownFilterType.ByValue)
            }).filter(i => i);

            //# add empty not empty? non empty to list
            hasEmpty && this.addBlankNonBlank(this.universalData, translates, hasNotEmtyData, true);
            let isMoment: boolean
            if (this.universalData.length){
                isMoment = this.universalData.some(item => moment.isMoment(item.value));
                selectedObj = isMoment
                    ? this.helper.arrToObjMoment(selectedData, 'value', 'format')
                    : this.helper.arrToObj(selectedData, 'value');
            }

            // console.log(selectedObj, 'selectedObj')

            this.universalData.forEach(item => {
                //item.value = item.name;
                let key: string = isMoment ? (item.value as Moment).format() : item.value as string;
                if (selectedObj[key]){
                    item.selected = selectedObj[key].selected;
                    item.position = selectedObj[key].position;
                }
            });

            this.universalData.sort((a: SlickFilterItem, b: SlickFilterItem) => b.position - a.position);

            //# apply filter, emit event filter
            this.applyFilter = (event: { data: any[], selected: any[] }): void => {
                if (!event){
                    this.showUnList = dropdownVisible = false;
                    this.addColumnTooltip(column, headerCell);
                    return;
                }

                selectedData.length = 0;

                let type = this.filterType(event.selected);
                if (type === DropdownFilterType.All){
                    event.data.forEach(item => selectedData.push(item));
                } else{
                    event.selected.forEach(item => selectedData.push(item));
                }

                const index = this.filteredColumns.indexOf(column.field);
                if (!selectedData.length){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                this.setInputFilterData(column, type, headerCell, selectedData);
                this.showUnList = dropdownVisible = false;
            };

            this.showUnList = dropdownVisible = true;
            this.removeDescription(column, headerCell);
            return true;
        }

        renderer.listen(btn, 'click', (e: MouseEvent) => {
            if (!btnClick(e)){
                this.helper.waitInterval(btnClick, 100);
            }
        });
    };

    /**
     * Generate events and emit after filter apply
     * @param column - slickgrid column
     * @param type - filterType
     * @param headerCell
     * @param selectedData
     */
    private setInputFilterData = (column: ISlickGridColumn<any>, type: number, headerCell: HTMLElement, selectedData: any[]): void => {
        let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'input', selectedData));
        this.setCustomRowHeight && this.removeEmptyRows();
        this.filterHelper.onGridFiltered(args);
        this.dataView.refresh();
        this.onFiltered.emit(args);
        this.appliedFilters.emit({filteredColumns: this.filteredColumns, filters: this.filterHelper.filters});
        if (headerCell){
            this.addColumnTooltip(column, headerCell);
        }
        this.checkAllSelect();
        this.setCustomRowHeight && this.addEmptyRows();
    }

    //# generate number filter
    private setInputFilterNumber = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: TranslateType): void => {
        if (this.denyFilters){
            return;
        }

        const renderer = column.inputFilter.renderer;
        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        //# add button to column header
        const btn = renderer.createElement('button');

        renderer.addClass(btn, 'fa-solid');
        renderer.addClass(btn, 'fa-filter');
        renderer.addClass(btn, 'input-filter-btn');
        renderer.setAttribute(btn, 'title', translates.Filter);
        renderer.appendChild(headerCell, btn);

        let inputValue1: string = '';
        let inputValue2: string = '';
        let dropdownVisible = false;
        let numberType: number = 1;

        //# when click on button render filter
        renderer.listen(btn, 'click', e => {
            e.stopPropagation();

            if (dropdownVisible){
                return;
            }

            const dropdown = renderer.createElement('div');
            renderer.addClass(dropdown, 'dropdown-menu');
            renderer.addClass(dropdown, 'number');
            const dropdownInput = renderer.createElement('input');
            renderer.setAttribute(dropdownInput, 'type', 'text');
            renderer.addClass(dropdownInput, 'dropdown-input-1');
            const delimiter = renderer.createElement('span');
            renderer.appendChild(delimiter, renderer.createText('-'));
            renderer.addClass(delimiter, 'dropdown-delimiter');
            const dropdownInput2 = renderer.createElement('input');
            renderer.setAttribute(dropdownInput2, 'type', 'text');
            renderer.addClass(dropdownInput2, 'dropdown-input-2');
            const apply = renderer.createElement('button');
            renderer.addClass(apply, 'btn');
            renderer.addClass(apply, 'btn-primary');
            renderer.addClass(apply, 'apply-filter');
            renderer.appendChild(apply, renderer.createText(translates.Apply));
            const clear = renderer.createElement('button');
            renderer.addClass(clear, 'btn');
            renderer.addClass(clear, 'btn-primary');
            renderer.addClass(clear, 'clear-filter');
            renderer.appendChild(clear, renderer.createText(translates.Clear));
            const dropdownFooter = renderer.createElement('div');
            renderer.addClass(dropdownFooter, 'dropdown-footer');
            const dropdownBtnWrp = renderer.createElement('div');
            const select = renderer.createElement('select');
            renderer.addClass(select, 'dropdown-select');

           this.filterHelper.renderSelect(renderer, select, translates);
            renderer.appendChild(dropdown, select);
            renderer.appendChild(dropdown, dropdownInput);
            renderer.appendChild(dropdown, delimiter);
            renderer.appendChild(dropdown, dropdownInput2);
            renderer.addClass(dropdownBtnWrp, 'dropdown-btn-wrp');
            renderer.appendChild(dropdown, dropdownBtnWrp);
            renderer.appendChild(dropdown, dropdownBtnWrp);

            renderer.appendChild(dropdownFooter, apply);
            renderer.appendChild(dropdownFooter, clear);
            renderer.appendChild(dropdown, dropdownFooter);


            if (inputValue1){
                dropdownInput.value = inputValue1;
            }

            if (inputValue2){
                dropdownInput2.value = inputValue2;
            }

            select.value = numberType;

            //# show two input if beetween
            const showSecondInput = (show: boolean): void => {
                if (show){
                    renderer.addClass(dropdown, 'small');
                    renderer.addClass(dropdownInput2, 'show');
                    renderer.addClass(delimiter, 'show');
                } else{
                    renderer.removeClass(dropdown, 'small');
                    renderer.removeClass(dropdownInput2, 'show');
                    renderer.removeClass(delimiter, 'show');
                }
            };

            if (numberType === 7){
                showSecondInput(true);
            }

            renderer.listen(select, 'change', (e: any) => {
                if (e && e.target){

                    if (e.target.value === '7'){
                        showSecondInput(true);
                    } else{
                        showSecondInput(false);
                    }
                    numberType = this.helper.customParseNumber(e.target.value);
                }
            });

            renderer.listen(dropdownInput, 'keyup', (e: KeyboardEvent) => {
                if (e && e.target && e.keyCode === 13 && e.target as HTMLInputElement){
                    applyFilter();
                }
            });

            let timeout = setTimeout(() => {
                clearTimeout(timeout);
                timeout = null;
                dropdownInput.focus();
            }, 1);

            // let dropdownPopper: Popper;
            let removeListener: () => void;
            let removeKeyupListener: () => void;

            //# hide filrer
            const hideDropdown = (): void => {
                removeListener();
                removeKeyupListener();
                renderer.removeClass(dropdown, 'show');
                this.dropDownPopper.destroy();
                renderer.removeChild(column.inputFilter.dropdownContainer, dropdown);
                this.addColumnTooltip(column, headerCell);
                dropdownVisible = false;
            };

            //# validate entered into unputs data
            const validateData = (): boolean => {

                if (this.helper.customParseNumber(inputValue1) === null && this.helper.customParseNumber(inputValue2) === null){
                    return false;
                }

                if (isNaN(this.helper.customParseNumber(inputValue1)) || isNaN(this.helper.customParseNumber(inputValue2))){
                    return true;
                }

                return numberType === 7 ? this.helper.customParseNumber(inputValue1) >= this.helper.customParseNumber(inputValue2) ||
                    this.helper.customParseNumber(inputValue1) === null && this.helper.customParseNumber(inputValue2) !== null ||
                    this.helper.customParseNumber(inputValue2) === null && this.helper.customParseNumber(inputValue1) !== null
                    : false;
            };

            //# toggle highlight inputs after validation
            const displayValidation = (validate: boolean): void => {
                if (validate){
                    renderer.addClass(dropdownInput, 'wrong');
                    renderer.addClass(dropdownInput2, 'wrong');
                } else{
                    renderer.removeClass(dropdownInput, 'wrong');
                    renderer.removeClass(dropdownInput2, 'wrong');
                }
            };

            //# apply filter and emit event
            const applyFilter = (): void => {
                let validate = validateData();
                displayValidation(validate);
                if (validate) return;


                hideDropdown();
                let type: DropdownFilterType;

                type = inputValue1 ? DropdownFilterType.ByValue : DropdownFilterType.All;

                const index = this.filteredColumns.indexOf(column.field);
                if (!inputValue1){
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else{
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                let data: number[] = [this.helper.customParseNumber(inputValue1), this.helper.customParseNumber(inputValue2)];
                this.setInputFilterNumberData(column, type, numberType, data);
            };

            renderer.listen(dropdownInput, 'input', (e) => {
                inputValue1 = e.target.value;
                displayValidation(validateData());
            });
            renderer.listen(dropdownInput2, 'input', (e) => {
                inputValue2 = e.target.value;
                displayValidation(validateData());
            });

            renderer.listen(apply, 'click', () => applyFilter());

            const clearFilter = (): void => {
                inputValue1 = '';
                inputValue2 = '';
                numberType = 1;
                applyFilter();
            };

            renderer.listen(clear, 'click', () => clearFilter());

            renderer.appendChild(column.inputFilter.dropdownContainer, dropdown);
            this.dropDownPopper = new Popper(btn, dropdown, {placement: 'bottom-end'});
            renderer.setStyle(dropdown, 'width', `${130}px`);

            renderer.addClass(dropdown, 'show');

            setTimeout(() => {
                removeListener = renderer.listen('body', 'mousedown', (event: MouseEvent) => {
                    let target = event.target,
                        hideFilter: boolean = true;
                    if (!target || !(event.target instanceof HTMLElement)){
                        hideDropdown();
                        return;
                    }

                    if (btn && btn.isSameNode(target) && dropdownVisible){

                        let timeout = setTimeout(() => {
                            clearTimeout(timeout);
                            timeout = null;
                            hideDropdown();
                        }, 300);
                        return;
                    }

                    while (target){
                        if (dropdown && dropdown.isSameNode(target) || btn && btn.isSameNode(target)){
                            hideFilter = false;
                            break;
                        }

                        target = this.renderer.parentNode(target);
                    }

                    if (hideFilter){
                        hideDropdown();
                    }
                });

                removeKeyupListener = renderer.listen('body', 'keyup', (event: KeyboardEvent) => {
                    if (event){
                        switch (event.keyCode){
                            case 13:
                                applyFilter();
                                break;
                            case 27:
                                clearFilter();
                                break;
                        }
                    }
                });
            }, 1);

            this.removeDescription(column, headerCell);
            dropdownVisible = true;
        });
    }

    /**
     * Generate events and emit after filter apply
     * @param column - slickgrid column
     * @param type - filterType
     * @param headerCell
     * @param selectedData
     */
    private setInputFilterNumberData = (column: ISlickGridColumn<any>, type: number, numberType: number, data: any[]): void => {
        let args = new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, 'input-number', data, numberType));
        this.setCustomRowHeight && this.removeEmptyRows();
        this.filterHelper.onGridFiltered(args);
        this.dataView.refresh();
        this.onFiltered.emit(args);
        this.appliedFilters.emit({filteredColumns: this.filteredColumns, filters: this.filterHelper.filters});
        this.checkAllSelect();
        this.setCustomRowHeight && this.addEmptyRows();
        console.log(args, {filteredColumns: this.filteredColumns, filters: this.filterHelper.filters}, type, numberType, 'inputFilter')
    }

    //# render buttons for grouping and aggregation, toggle them
    private setGroupingBtn = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void => {

        if (this.denyGrouping || column.type === 'none'){
            // if (this.denyGrouping || column.type !== 'string' && column.type !== 'number'){
            return;
        }

        const renderer = column.grouping.renderer;

        //# render button for toggle grouping
        const btn = renderer.createElement('button');

        renderer.addClass(btn, 'fa-solid');
        renderer.addClass(btn, 'grouping-btn');
        renderer.setAttribute(btn, 'title', translates.Grouping);
        renderer.appendChild(headerCell, btn);

        let grouped: boolean = column.grouping.grouped;

        if (grouped){
            renderer.addClass(btn, 'fa-object-ungroup');
        } else{
            renderer.addClass(btn, 'fa-object-group');
        }


        // const selectedData: string[] = [];
        //# toggle grouping on click
        renderer.listen(btn, 'click', e => {
            e.stopPropagation();
            grouped = !grouped;
            if (grouped){
                renderer.removeClass(btn, 'fa-object-group');
                renderer.addClass(btn, 'fa-object-ungroup');
            } else{
                renderer.addClass(btn, 'fa-object-group');
                renderer.removeClass(btn, 'fa-object-ungroup');
            }
            column.grouping.grouped = grouped;
            this.onGrouping.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(column, grouped ? 'add' : 'remove')));
        });

        if (column.type !== 'number' || this.denyGrouping || this.denyAggregation || !column.grouping.aggregation){
            return;
        }

        //# render button for aggregations
        const btnAg = renderer.createElement('button');
        let dropdownVisible = false;

        renderer.addClass(btnAg, 'aggregate-btn');

        column.grouping.disableAggr && renderer.addClass(btnAg, 'disabled');

        //column.grouping.disableAggr && renderer.setAttribute(btnAg, 'disabled', true);

        renderer.appendChild(btnAg, renderer.createText('Ag'));
        renderer.setAttribute(btnAg, 'title', translates.Aggregation);
        renderer.appendChild(headerCell, btnAg);

        let aggregated: boolean = column.grouping.aggregated;
        let aggregation: AggregationSelector = this.helper.copyAggregatorSelector(column.grouping.aggregation);

        // if (!aggregation){
        //     aggregation = new AggregationSelector(column.id, column.name, new Aggregation(false, false, false, false))
        // }

        aggregated ? renderer.addClass(headerCell, 'aggregated') : renderer.removeClass(headerCell, 'aggregated');

        //# render list of aggregations on click
        renderer.listen(btnAg, 'click', e => {
            e.stopPropagation();

            if (dropdownVisible || column.grouping.disableAggr){
                return;
            }

            const clear = renderer.createElement('button');
            const apply = renderer.createElement('button');
            const dropdown = renderer.createElement('div');
            const dropdownBtnWrp = renderer.createElement('div');
            const dropdownFooter = renderer.createElement('div');
            renderer.addClass(dropdown, 'dropdown-menu');
            renderer.addClass(dropdownBtnWrp, 'dropdown-btn-wrp');
            renderer.addClass(dropdownFooter, 'dropdown-footer');
            renderer.addClass(apply, 'btn');
            renderer.addClass(apply, 'btn-sm');
            renderer.addClass(apply, 'btn-primary');
            renderer.addClass(apply, 'apply-filter');
            renderer.addClass(clear, 'btn');
            renderer.addClass(clear, 'btn-sm');
            renderer.addClass(clear, 'btn-primary');
            renderer.addClass(clear, 'clear-filter');
            renderer.appendChild(clear, renderer.createText(translates.Clear));
            renderer.appendChild(apply, renderer.createText(translates.Apply));
            renderer.appendChild(dropdownFooter, apply);
            renderer.appendChild(dropdownFooter, clear);
            renderer.appendChild(dropdown, dropdownBtnWrp);
            renderer.appendChild(dropdown, dropdownFooter);

            //let dropdownPopper: Popper;

            let removeListener: () => void;
            let removeKeyupListener: () => void;

            //# hide aggregation list
            const hideDropdown = (): void => {
                removeListener();
                removeKeyupListener();
                renderer.removeClass(dropdown, 'show');
                this.dropDownPopper.destroy();
                renderer.removeChild(column.grouping.dropdownContainer, dropdown);
                this.addColumnTooltip(column, headerCell);
                dropdownVisible = false;
            };

            //# toggle aggregation
            const addSelected = (prop: string): void => {
                aggregation.data[prop] = !aggregation.data[prop];
            };

            //# emit selected aggregation and apply it
            const applyFilter = () => {
                hideDropdown();
                this.toggleAggregation(column, aggregated, aggregation, headerCell);

                // column.grouping.aggregated = aggregated = this.helper.hasSelectedAg(aggregation);
                // column.grouping.aggregation = null;
                // column.grouping.aggregation = aggregation;
                // aggregated ? renderer.addClass(headerCell, 'aggregated') : renderer.removeClass(headerCell, 'aggregated');
                // this.onAggregated.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(column, aggregated ? 'add' : 'remove', [aggregation])));
            };

            //# add aggregation item to list of aggregations
            const appendDropdownItem = (prop: string, text: string, onClick: () => void): void => {
                const menuItem = renderer.createElement('button');
                const wrpMenuItem = renderer.createElement('div');
                const inputMenuItem = renderer.createElement('input');
                renderer.setAttribute(inputMenuItem, 'type', 'checkbox');
                renderer.setAttribute(menuItem, 'type', 'button');
                renderer.addClass(wrpMenuItem, 'dropdown-item-wrp');
                renderer.addClass(menuItem, 'dropdown-item');
                renderer.addClass(inputMenuItem, 'dropdown-checkbox');
                renderer.appendChild(menuItem, renderer.createText(text));
                renderer.listen(wrpMenuItem, 'click', onClick);

                if (aggregation.data[prop]){
                    inputMenuItem.checked = true;
                }

                renderer.listen(wrpMenuItem, 'click', ($event: any) => {

                    let target = $event.target;
                    if (target){
                        let input: HTMLInputElement;
                        if (target.classList.contains('dropdown-item')){
                            input = target.parentElement.querySelector('.dropdown-checkbox');
                        } else if (target.classList.contains('dropdown-item-wrp')){
                            input = target.querySelector('.dropdown-checkbox');
                        }

                        if (input){
                            input.checked = !input.checked;
                        }

                    }
                });

                renderer.appendChild(wrpMenuItem, inputMenuItem);
                renderer.appendChild(wrpMenuItem, menuItem);
                renderer.appendChild(dropdownBtnWrp, wrpMenuItem);
            };

            //# get translated aggregations
            const getText = (prop: string): string => {
                let result: string = '';
                switch (prop){
                    case 'avg':
                        result = translates.Avg;
                        break;
                    case 'sum':
                        result = translates.Sum;
                        break;
                    case 'min':
                        result = translates.Min;
                        break;
                    case 'max':
                        result = translates.Max;
                        break;
                }
                return result;
            };

            for (let prop in aggregation.data){
                let text: string = getText(prop);
                appendDropdownItem(prop, text, () => addSelected(prop))
            }

            renderer.listen(apply, 'click', () => applyFilter());
            renderer.listen(clear, 'click', () => {
                aggregation = this.helper.copyAggregatorSelector(column.grouping.aggregation);
                hideDropdown();
            });
            renderer.appendChild(column.grouping.dropdownContainer, dropdown);
            this.dropDownPopper = new Popper(btnAg, dropdown, {placement: 'bottom-end'});
            renderer.setStyle(dropdown, 'width', `${100}px`);
            renderer.addClass(dropdown, 'show');

            setTimeout(() => {
                removeListener = renderer.listen('body', 'mousedown', (event: MouseEvent) => {
                    // console.log(event.target, 'event.target')
                    let target = event.target,
                        hideFilter: boolean = true;
                    if (!target || !(event.target instanceof HTMLElement)){
                        hideDropdown();
                        return;
                    }

                    if (btnAg && btnAg.isSameNode(target) && dropdownVisible){
                        let timeout = setTimeout(() => {
                            clearTimeout(timeout);
                            timeout = null;
                            hideDropdown();
                        }, 300);
                        return;
                    }
                    //console.log(dropdown, 'body  mousedown dropdown');
                    while (target){
                        //console.log(target, 'body  mousedown target');
                        if (dropdown && dropdown.isSameNode(target) || btnAg && btnAg.isSameNode(target)){
                            hideFilter = false;
                            break;
                        }

                        target = this.renderer.parentNode(target);
                    }
                    //console.log(hideFilter, 'body  mousedown hideFilter');

                    if (hideFilter){
                        applyFilter();
                    }
                });

                removeKeyupListener = renderer.listen('body', 'keyup', (event: KeyboardEvent) => {
                    if (event){
                        switch (Number(event.key)){
                            case 13:
                                applyFilter();
                                break;
                            case 27:
                                hideDropdown();
                                break;
                        }
                    }
                });


            }, 1);
            this.removeDescription(column, headerCell);
            dropdownVisible = true;
        });
    };

    private readonly toggleAggregation = (column: ISlickGridColumn<any>, aggregated: boolean, aggregation: AggregationSelector, headerCell: HTMLElement): void => {
        column.grouping.aggregated = aggregated = this.helper.hasSelectedAg(aggregation);
        column.grouping.aggregation = null;
        column.grouping.aggregation = aggregation;
        aggregated ? this.renderer.addClass(headerCell, 'aggregated') : this.renderer.removeClass(headerCell, 'aggregated');
        this.onAggregated.emit(new EventArgs(new Slick.EventData(), new OnGroupingEventArgs(column, aggregated ? 'add' : 'remove', [aggregation])));
    }

    //# add description tooltip to grid header
    private addColumnTooltip = (column: ISlickGridColumn<any>, headerCellOuter?: HTMLElement, test = false): void => {
        let headerCell = headerCellOuter ? headerCellOuter : $('.' + this.gridGUID + '_' + (column.regColId ? column.regColId : column.id)),
            tooltip: string = '';
        let $span = $(headerCell).find('.slick-column-name');
        if (column.description && column.description !== column.descriptionKey){
            tooltip = column.description;
        } else {
            if ($span.length){
                tooltip = this.manualEllipsis
                    ? column.addedDots
                        ? column.name
                        : $span.innerWidth() + 0.5 < $span[0].scrollWidth
                            ? column.name
                            : ''
                    : $span.innerWidth() + 0.5 < $span[0].scrollWidth
                        ? column.name
                        : '';
            }
        }

        /*let $span = $(headerCell).find('.slick-column-name');
        console.log(
            column.name,
            column.addedDots,
            tooltip,
            $span.innerWidth(),
            $span[0].scrollWidth,
            !!this.manualEllipsis,
            'addColumnTooltip',
            this.manualEllipsis
                ? column.addedDots
                    ? column.name
                    : ''
                : $span.innerWidth() + 0.5 < $span[0].scrollWidth
                    ? column.name :
                    '');*/

        if (!tooltip || (column.name === tooltip && tooltip.match(this.helper.regExpFindTags))){
            return;
        }

        const hasTooltip = $span.data('bs.tooltip') !== undefined;
        if (!hasTooltip){
            this.addTooltip($span[0], tooltip);
        }
    }

    private addTooltip = (el: HTMLElement, tooltip: string): void => {
        if (!el){
            return;
        }
        this.renderer.setAttribute(el, 'title', tooltip);
        this.renderer.setAttribute(el, 'data-toggle', 'tooltip');
        this.renderer.setAttribute(el, 'data-html', 'true');
        // this.renderer.setAttribute(headerCell, 'data-container', '#' + this.gridGUID);
        // this.helper.tooltipFuncGridAdd(span, `#${this.gridGUID}`, text, this.gridRef.nativeElement.offsetWidth - 20);
        this.renderer.listen(el, 'mouseleave', (e: MouseEvent) => this.helper.remTooltip(e));
        $(el).tooltip({
            trigger: 'hover',
            offset: "50px, 0",
            boundary: document.body,
            template: '<div class="tooltip big-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
        })
    }

    //# add
    private addCustomTextToColumn = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void =>{

        //# render button for aggregations
        const span = this.renderer.createElement('span');
        let dropdownVisible = false;

        this.renderer.addClass(span, 'custom-header-text');
        this.renderer.setStyle(span, 'background-color', column.customText.background);
        // console.log(column.field, column.customText, 'addCustomTextToColumn')
        this.addTooltip(span, this.translates.RowsForOrder);


        // renderer.addClass(btnAg, 'disabled');

        //column.grouping.disableAggr && renderer.setAttribute(btnAg, 'disabled', true);

        this.renderer.appendChild(span, this.renderer.createText(column.customText.text));
        // renderer.setAttribute(btnAg, 'title', translates.Aggregation);
        this.renderer.appendChild(headerCell, span);
        // $(span).tooltip({trigger: 'hover', offset: "50px, 0", template: '<div class="tooltip stocks-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'})
    }

    //# remove description tooltip from grid header
    private removeDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void => {
        $(headerCell).find('.slick-column-name').tooltip('dispose')
    }

    //# hide description tooltip from grid header
    private hideDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void => {
        $(headerCell).tooltip('hide')
    }

    //# show description tooltip from grid header
    private showDescription = (column: ISlickGridColumn<any>, headerCell: HTMLElement): void => {
        $(headerCell).tooltip('show')
    }

    //# set manual ellipsis to text in column header
    private manualEllipsisFunc = (columnId: string, headerCellOuter?: HTMLElement, test: boolean = false): void => {
        // this.helper.wait(() => {


        const column = this.columns.find(c => c.id === columnId);

        if (column.name.match(/<.+<\//g)){
            return;
        }

        let headerCell = headerCellOuter ? headerCellOuter : $('.' + this.gridGUID + '_' + (column.regColId ? column.regColId : column.id));
        this.helper.wait(() => {
            let $span = $(headerCell).find('.slick-column-name').first(),
                lineWidth = $span.outerWidth(),
                $container = $(this.renderer.createElement('div'))
                    .css({
                        display: 'inline',
                        width: '10000px',
                        visibility: 'hidden',
                        position: 'absolute',
                        left: '10000px',
                        fontsize: this.manualEllipsis.fontSize
                    }),
                nameArr = column.name.split(' '),
                elArr: { text: string, el: JQuery<HTMLElement>, width: number }[] = [];
            // console.log(lineWidth, column.name)
            nameArr.forEach((text, i, arr) => {
                let padding = arr.length - (i + 1) > 0 ? '0 3.75px 0 0' : 0;
                let $el = $span
                    .clone()
                    .css({
                        display: 'inline',
                        width: 'auto',
                        visibility: 'hidden',
                        position: 'absolute',
                        fontsize: this.manualEllipsis.fontSize,
                    })
                    .text(text)
                    .appendTo($container);
                elArr.push({text, el: $el, width: 0})
            });
            let $2a = $span
                .clone()
                .css({
                    display: 'inline',
                    width: 'auto',
                    visibility: 'hidden',
                    position: 'absolute',
                    fontsize: this.manualEllipsis.fontSize,
                })
                .text('a a')
                .appendTo($container);
            let $a = $span
                .clone()
                .css({
                    display: 'inline',
                    width: 'auto',
                    visibility: 'hidden',
                    position: 'absolute',
                    fontsize: this.manualEllipsis.fontSize,
                })
                .text('a')
                .appendTo($container);
            $container.appendTo(`#${this.gridGUID}`);
            let fullWidth = 0,
                whiteSpace = $2a.outerWidth() - $a.outerWidth() * 2
            elArr.forEach(item => fullWidth += item.el.outerWidth());

            if(column.id === 'TransitNeed'){
                // console.log(column.name, column.id, elArr.map(e => {return  {text: e.text, width: e.el.outerWidth()}}),
                //     whiteSpace, 'whitespace',
                //     nameArr, 'nameArr', lineWidth, 'lineWidth', fullWidth, 'fullWidth');
            }


            const needDot = (): boolean => {
                let lines: { line: number, width: number, text: string }[] = [];
                let cutted = elArr.some(item => {
                    if (!lines.length){
                        lines.push({line: 1, width: 0, text: ''})
                    }

                    let line: { line: number, width: number, text: string } = lines[lines.length - 1];
                    let outerWidth = item.el.outerWidth();
                    if (line.width === 0 && outerWidth >= lineWidth){
                        line.text = item.text;
                        line.width = item.el.outerWidth();
                        lines.push({line: lines.length + 1, width: 0, text: ''})
                    } else if (line.width + outerWidth >= lineWidth){
                        lines.push({line: lines.length + 1, width: item.el.outerWidth() + whiteSpace, text: item.text})
                    } else if (line.width + outerWidth < lineWidth){
                        line.text ? line.text += ' ' + item.text : line.text = item.text;
                        line.width += item.el.outerWidth() + whiteSpace;
                    }

                    if (column.id === 'TransitNeed'){
                        // console.log(line.width === 0 && line.width + outerWidth - 3.75 >= lineWidth, line.width + outerWidth - 3.75 >= lineWidth, line.width + outerWidth < lineWidth)
                        //
                        // console.log(item.text, 'item.text', line.text, 'line.text', line.width, 'line.width', outerWidth, lineWidth, 'line')
                    }


                    if (lines.length > this.manualEllipsis.strings){
                        lines.length = this.manualEllipsis.strings;
                        let name = lines.map(line => line.text).join(' ');
                        if (lineWidth - lines[lines.length - 1].width > 8){
                            name = name + '....';
                        } else{
                            name = name.substring(0, name.length - 3) + '....';
                        }

                        $span.text(name);
                        return true;
                    }
                })
                if (column.id === 'TransitNeed'){
                    // console.log(column.name, lines, 'lines')
                }

                !cutted && $span.text(column.name);
                return cutted;
            }

            column.addedDots = needDot();
            this.addColumnTooltip(column, headerCell[0] ? headerCell[0] : headerCell, test )
            $container.remove();
        }, 5)
    }

    //# on grid header cell rendered add filter, aggregation and dropdown to header cell
    private onGridHeaderCellRendered = (event: DOMEvent, args: Slick.OnHeaderCellRenderedEventArgs<any>) => {
        const column = args.column as ISlickGridColumn<any>;
        //this.renderedColumns.push(args);

        if (!column)
            return;

        if (this.cancelSort){
            // const container = args.node.querySelector('.slick-column-name');
            const container = args.node;
            container.addEventListener('dblclick', () => {
                this.grid.setSortColumns([]);

                // let data = this.dataView.getItems();
                //console.log(data)
                this.dataView.sort((a: any, b: any) => {
                    return a['id'] - b['id'];
                }, true);

                this.grid.invalidate();
                this.grid.render();
                this.helper.wait(() => this.onSorted.emit(null));

                //this.dataView.fastSort('id', false)
            })
        }

        $(args.node).addClass(this.gridGUID + '_' + (args.column.regColId ? args.column.regColId : args.column.id));

        if (column.dropdownFilter)
            this.setDropdownFilter(column, args.node, this.translates);

        if (column.inputFilter && column.inputFilter.type === 'string')
            this.setInputFilter(column, args.node, this.translates);

        if (column.inputFilter && column.inputFilter.type === 'number')
            this.setInputFilterNumber(column, args.node, this.translates);

        if (column.grouping)
            this.setGroupingBtn(column, args.node, this.translates);

        // if (column.description){
        // this.addColumnTooltip(column, args.node);
        // }

        if (column.customText){
            this.addCustomTextToColumn(column, args.node);
        }

        if (this.manualEllipsis){
            this.manualEllipsisFunc(column.id, args.node);
        } else {
            this.addColumnTooltip(column, args.node);
        }

        if (column.selectAll && column.selectAll.allSelectable){
            const input = this.renderer.createElement('input') as HTMLInputElement;
            input.type = 'checkbox';
            this.checkBoxHeader = input;
            this.renderer.listen(input,
                'change',
                () => {
                    let items: any[] = this.dataView.getItems();

                    for (const item of items){
                        !item.disabled ? item[column.field] = input.checked : null;
                    }

                    if (!this.grid)
                        return;

                    this.grid.invalidate();
                    this.grid.render();

                    if (column.selectAll.onSelectionChanged)
                        column.selectAll.onSelectionChanged();
                });

            const container = args.node.querySelector('.slick-column-name');
            this.renderer.appendChild(container, input);
            this.renderer.addClass(container, 'text-center');
        }

        if (column.selectAll2){
            this.checkBoxHeader = args.node.querySelector('input');
            let wrapper = args.node.querySelector('.out-chkb-wrp');
            this.addTooltip(wrapper as HTMLElement, this.translates.SelectAll);
            this.renderer.listen(this.checkBoxHeader, 'change', e => this.selectAll(e.target.checked));
        }

        //$(args.data.node).on('hidden.bs.dropdown',
        //    () => {
        //        dropdownVisible = false;

        //        //$(btn).dropdown('destroy');
        //        this.renderer.removeChild('body', dropdown);
        //        //this.renderer.removeAttribute(btn, 'data-toggle');
        //    });
    }

    public readonly updateEllipsis = (): void => {
        this.columns.forEach(column => {
            if (this.manualEllipsis){
                this.manualEllipsisFunc(column.id);
            } else {
                this.addColumnTooltip(column);
            }
        })
    }

    public selectAll = (select: boolean): void => {
        let items = this.helper.getRowsFromGridAll(this.dataView);
        items.forEach(item => !item.disabled ? item.selected = select : null);
        this.selectAllEm.emit(select);
        if (!this.grid)
            return;

        this.grid.invalidate();
        this.grid.render();
    }

    public checkAllSelect = (): void => {
        this.helper.wait(() => {
            let items = this.helper.getRowsFromGridAll(this.dataView),
                allSelected = items.length ? items.every(item => item.selected) : false;
            if (this.checkBoxHeader){
                this.checkBoxHeader.checked = allSelected;
            }
        })

    }

    public readonly initGrouping = (
        groupItemMetadataProvider: Slick.Data.GroupItemMetadataProvider<any>,
    ): void => {
        this.helper.wait(() => this.grid.registerPlugin(groupItemMetadataProvider), 1);
    }

    public readonly setDefaultTotalsFormatter = (): void => {
        this.grid.getColumns().forEach(c => c.groupTotalsFormatter = this.helper.totalsFormatter);
    }

    public readonly setCustomTotalsFormatter = (totalsFormatter: (totals: any, colDef: any) => string): void => {
        this.grid.getColumns().forEach(c => c.groupTotalsFormatter = totalsFormatter);
    }

    private readonly getWordLength = (str: string, tmpFont: FontSize): number => {
        let stringArr: string[] = [];
        let length: number = 0;
        for (let i = 0; i < str.length; i++){
            stringArr.push(str[i]);
        }

        const addLength = (c: string) => {
            length += this.fontSize.dimensions[c]
        }

        let needSave: boolean = false;

        stringArr.forEach(c => {
            if (this.fontSize.dimensions[c]){
                addLength(c);
            } else {
                tmpFont.dimensions[c] = 0;
                this.calculateSymbolWidth(tmpFont);
                this.fontSize.dimensions[c] = tmpFont.dimensions[c];
                addLength(c);
                needSave = true;
            }
        });

        return length;
    }

    public readonly setRowHeight = (setCustomRowHeight: boolean = false): void => {
        // console.log(this.setCustomRowHeight, this.fontSize, 'setRowHeight')
        if (!this.setCustomRowHeight && !setCustomRowHeight){
            return
        }

        let columns = this.grid.getColumns();
        let tmpFont: FontSize = new FontSize(this.fontSize.name, this.fontSize.size);
        // let items = this.dataView.getItems();


        this.dataView.getItems().forEach( row => this.calculateRowHeight(row, columns, tmpFont));
        let needSave: boolean = false;
        for (let symbol in tmpFont.dimensions){
            needSave = true;
        }
        needSave && this.common.saveFontDimensions(tmpFont).subscribe(r => r);
        this.removeEmptyRows();
        this.addEmptyRows();
    }

    public readonly calculateRowHeight = (row: any , columns?: Slick.Column<any>[], tmpFont?: FontSize): void => {
        if (!columns){
            columns = this.grid.getColumns();
        }


        if (!tmpFont){
            tmpFont = new FontSize(this.fontSize.name, this.fontSize.size);
        }

        row['rowHeight'] = 1;
        columns.forEach((c, i) => {
            if (c.type !== 'number'){
                if (row[c.field]){
                    let words: string[] = [];
                    let formattedString = this.helper.dataItemColumnValueExtractor(row, c);
                    formattedString.split(' ').map(w =>  w.split('-')).forEach( w => w.forEach( wIn => words.push(wIn)));

                    let wordsLength: number[] = words.map(s => this.getWordLength(s, tmpFont)),
                        width = c.width - 8,
                        rowsQnt: number = 1,
                        length: number = 0;

                    wordsLength.forEach((wl) => {
                        wl = (Math.round(wl*100)/100)*0.97;

                        if (this.customRowLength){
                            length = this.customRowLength(length, wl, row, i)
                        }

                        if (length === 0){
                            length += wl
                        } else{
                            length += wl + this.fontSize.dimensions[' '];
                        }

                        if (length > width && length === wl){
                            if (wordsLength.length > 1){
                                length = 0;
                                rowsQnt++;
                            }
                        } else if (length > width){
                            length = wl;
                            rowsQnt++;
                        }
                    })

                    if (rowsQnt > row['rowHeight']){
                        row['rowHeight'] = rowsQnt;
                    }
                }

            }

            if (++i === columns.length){
                row['rowHeight'] = row['rowHeight'] - Math.trunc(row['rowHeight'] / 3);
            }
        })
    }

    public customRowHeightFilterFunc: (row: any[]) => any[];

    public customRowLength: (length: number, wordLength: number, row: any, i: number) => number;

    public readonly addEmptyRows = (): void => {
        // console.log('addEmptyRows 1')
        // this.dataView.beginUpdate();
        // console.log('addEmptyRows 2')

        let items = this.helper.getRowsFromGridAll(this.dataView).map(i => i);
        let items2 = this.dataView.getItems().map(i => i);

        const getIdxById = (id: string): number => {
            return items2.findIndex(i => i.id === id);
        }

        if (items && items.length){
            if (this.customRowHeightFilterFunc){
                items = this.customRowHeightFilterFunc(items);
            }

            items.forEach(item => {
                if (item['rowHeight'] && item['rowHeight'] > 1){
                    // let idxParent = this.dataView.getIdxById(item.id);
                    let idxParent = getIdxById(item.id);
                    for (let idx = 1; idx < item['rowHeight']; idx++){
                        items2.splice(idxParent + idx, 0, this.getEmptyItem(item, idx))
                        // this.dataView.insertItem(idxParent + idx, this.getEmptyItem(item, idx, filteredColumnsZoom));
                    }

                }
            })
            this.dataView.setItems(items2);
        }
        // console.log(this.customRowHeight, items, 'addEmptyRows 3')
        // this.dataView.endUpdate();
        // console.log('addEmptyRows 4')

        this.grid && this.grid.invalidate();
        // this.grid.invalidate();
        // this.helper.wait(this.grid.invalidate, 10)
        // console.log(this.customRowHeight, this.dataView.getItems(), this.dataView.getLength(), 'addEmptyRows 5')
    }

    public readonly removeEmptyRows = (complete: boolean = false): void => {
        // console.log('removeEmptyRows 1')
        // this.dataView.beginUpdate();

        let items = this.dataView.getItems();

        if (items && items.length){
            this.helper.remFromArr(items, 'hideRow', true);
            complete && items.forEach(item => item['rowHeight'] = null);
            this.dataView.setItems(items);
        }

        // this.dataView.endUpdate();
        // console.log('removeEmptyRows 2')
        this.grid && this.grid.invalidate();
        // console.log('removeEmptyRows 3')
    }

    private readonly getEmptyItem = (parent: any, offset: number): any => {
        let item: any = {};

        this.filteredColumns.forEach(fc => item[fc] = parent[fc]);
        this.zoomFilteredColumns.forEach(fc => item[fc] = parent[fc]);
        // let item: any = this.helper.deepCopy(parent);
        item.id = parent.id + "." + offset;
        item.hideRow = true;
        return item
    }

    private readonly generateFontSize = (name: string, size: string, codes?: number[]): FontSize => {
        let fontSize: FontSize = new FontSize(name, size);
        codes = codes
            ? codes
            : this.helper.generateNumberArr(32, 126).concat(this.helper.generateNumberArr(1025, 1279))
        codes.forEach(c => fontSize.dimensions[String.fromCharCode(c)] = 0);
        this.calculateSymbolWidth(fontSize);
        fontSize.dimensions[' '] = fontSize.dimensions['0']*0.5;
        return fontSize;
    }

    private readonly calculateSymbolWidth = (fontSize: FontSize): void => {
        let elArr: { text: string, el: JQuery<HTMLElement>, width: number }[] = [];
        let $container = $(this.renderer.createElement('div'));
        for (let symbol in fontSize.dimensions){
            let $span = $(this.renderer.createElement('span'));
            $span.css({
                display: 'inline',
                width: 'auto',
                visibility: 'hidden',
                position: 'absolute',
                fontsize: fontSize.size,
                fontfamily: fontSize.name
            })
                .text(symbol)
                .appendTo($container);
            elArr.push({text: symbol, el: $span, width: 0})
        }

        $container.appendTo('body');
        elArr.forEach(item => fontSize.dimensions[item.text] = item.el.outerWidth());
        $container.remove();
    }
}




// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.component-base.ts